export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** Long type */
    Long: { input: any; output: any };
};

export type InputComSnapCamerakitAdminV2AdAccount = {
    readonly id: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2ApiToken = {
    readonly createdTsMillis: InputMaybe<Scalars["Float"]["input"]>;
    readonly stage: InputMaybe<ComSnapCamerakitAdminV2Stage>;
    readonly token: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2AppInfo = {
    readonly apiTokens: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2ApiToken>>>;
    readonly appIconUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly internalAppName: InputMaybe<Scalars["String"]["input"]>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
    readonly platformType: InputMaybe<ComSnapCamerakitAdminV2PlatformType>;
    readonly prodLiveVersion: InputMaybe<Scalars["Int"]["input"]>;
    readonly stagingLiveVersion: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2AppInput = {
    readonly internalAppName: InputMaybe<Scalars["String"]["input"]>;
    readonly platformType: InputMaybe<ComSnapCamerakitAdminV2PlatformType>;
};

export type InputComSnapCamerakitAdminV2AppVersion = {
    readonly appDescription: InputMaybe<Scalars["String"]["input"]>;
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly appName: InputMaybe<Scalars["String"]["input"]>;
    readonly features: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2Feature>>>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
    readonly reviewState: InputMaybe<ComSnapCamerakitAdminV2ReviewState>;
    readonly version: InputMaybe<Scalars["Int"]["input"]>;
    readonly versionName: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2ApplicationAuthorizedOperationsRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2ApplicationAuthorizedOperationsResponse = {
    readonly appAuthorizedOperations: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2AuthorizedOperation>>
    >;
};

export type InputComSnapCamerakitAdminV2AuthorizedOperation = {
    readonly authOperation: InputMaybe<ComSnapCamerakitAdminV2AuthOperation>;
    readonly authOperationTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InputComSnapCamerakitAdminV2CreateApplicationRequest = {
    readonly appInfo: InputMaybe<InputComSnapCamerakitAdminV2AppInput>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2CreateApplicationResponse = {
    readonly appInfo: InputMaybe<InputComSnapCamerakitAdminV2AppInfo>;
};

export type InputComSnapCamerakitAdminV2CreateConnectionBulkRequest = {
    readonly createRequests: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2CreateConnectionRequest>>>;
};

export type InputComSnapCamerakitAdminV2CreateConnectionBulkResponse = {
    readonly connections: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2GroupLensConnection>>>;
};

export type InputComSnapCamerakitAdminV2CreateConnectionRequest = {
    readonly groupId: InputMaybe<Scalars["String"]["input"]>;
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly priority: InputMaybe<Scalars["Int"]["input"]>;
    readonly schedule: InputMaybe<InputComSnapCamerakitAdminV2Schedule>;
    readonly vendorData: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type InputComSnapCamerakitAdminV2CreateVersionRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly appVersionName: InputMaybe<Scalars["String"]["input"]>;
    readonly sourceVersion: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2CreateVersionResponse = {
    readonly appVersion: InputMaybe<InputComSnapCamerakitAdminV2AppVersion>;
};

export type InputComSnapCamerakitAdminV2DeleteHostedLensRequest = {
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2DeleteHostedLensResponse = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2EnableCameraKitFeatureRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly sourceVersion: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2EnableCameraKitFeatureResponse = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2Feature = {
    readonly enabled: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly featureScopeName: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GenerateApiTokenRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly stage: InputMaybe<ComSnapCamerakitAdminV2Stage>;
};

export type InputComSnapCamerakitAdminV2GenerateApiTokenResponse = {
    readonly apiToken: InputMaybe<InputComSnapCamerakitAdminV2ApiToken>;
};

export type InputComSnapCamerakitAdminV2GenerateHostedLensRequest = {
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GenerateHostedLensResponse = {
    readonly lens: InputMaybe<InputComSnapCamerakitAdminV2HostedLens>;
};

export type InputComSnapCamerakitAdminV2GetAdAccountsRequest = {
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetAdAccountsResponse = {
    readonly adAccounts: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2AdAccount>>>;
};

export type InputComSnapCamerakitAdminV2GetAppVendorUuidOptinFlagRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetAppVendorUuidOptinFlagResponse = {
    readonly appVendorOptInEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetApplicationInfoRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetApplicationInfoResponse = {
    readonly application: InputMaybe<InputComSnapCamerakitAdminV2AppInfo>;
};

export type InputComSnapCamerakitAdminV2GetHostedLensListRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetHostedLensListResponse = {
    readonly lenses: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2HostedLens>>>;
};

export type InputComSnapCamerakitAdminV2GetHostedLensRequest = {
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetHostedLensResponse = {
    readonly lens: InputMaybe<InputComSnapCamerakitAdminV2HostedLens>;
};

export type InputComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionResponse = {
    readonly hasSubscription: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly subscriptionExpiry: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetUserInfoRequest = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetVersionListRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GetVersionListResponse = {
    readonly versions: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2AppVersion>>>;
};

export type InputComSnapCamerakitAdminV2Group = {
    readonly createdAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly description: InputMaybe<Scalars["String"]["input"]>;
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly isPinned: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lenses: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LensInGroup>>>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
    readonly readOnly: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly status: InputMaybe<ComSnapCamerakitAdminV2GroupStatus>;
    readonly totalNumLenses: InputMaybe<Scalars["Int"]["input"]>;
    readonly updatedAt: InputMaybe<InputGoogleProtobufTimestamp>;
};

export type InputComSnapCamerakitAdminV2GroupLensConnection = {
    readonly connectionId: InputMaybe<Scalars["String"]["input"]>;
    readonly group: InputMaybe<InputComSnapCamerakitAdminV2Group>;
    readonly lens: InputMaybe<InputComSnapCamerakitAdminV2Lens>;
    readonly priority: InputMaybe<Scalars["Int"]["input"]>;
    readonly schedule: InputMaybe<InputComSnapCamerakitAdminV2Schedule>;
    readonly vendorData: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type InputComSnapCamerakitAdminV2GroupListRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly lensLimit: InputMaybe<Scalars["Int"]["input"]>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly offset: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly query: InputMaybe<ComSnapCamerakitAdminV2GroupListRequestQuery>;
};

export type InputComSnapCamerakitAdminV2GroupListWithConnections = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly groupsWithConnections: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2GroupWithConnections>>
    >;
    readonly hasMore: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly total: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GroupRequest = {
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly lensLimit: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2GroupSaveRequest = {
    readonly description: InputMaybe<Scalars["String"]["input"]>;
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly lens: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LensInGroup>>>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly status: InputMaybe<ComSnapCamerakitAdminV2GroupStatus>;
};

export type InputComSnapCamerakitAdminV2GroupWithConnections = {
    readonly connections: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2GroupLensConnection>>>;
    readonly group: InputMaybe<InputComSnapCamerakitAdminV2Group>;
};

export type InputComSnapCamerakitAdminV2HostedLens = {
    readonly compoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly createdAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly createdBy: InputMaybe<Scalars["String"]["input"]>;
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly link: InputMaybe<Scalars["String"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly reference: InputMaybe<Scalars["String"]["input"]>;
    readonly status: InputMaybe<ComSnapCamerakitAdminV2HostedLensStatus>;
    readonly updatedAt: InputMaybe<InputGoogleProtobufTimestamp>;
};

export type InputComSnapCamerakitAdminV2InternalLabels = {
    readonly firstParty: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly live: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly managed: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2IsCameraKitEnabledOrganizationRequest = {
    readonly applicationType: InputMaybe<ComSnapCamerakitAdminV2PlatformType>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2IsCameraKitEnabledOrganizationResponse = {
    readonly isEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2IsCameraKitEnabledRequest = {
    readonly applicationType: InputMaybe<ComSnapCamerakitAdminV2PlatformType>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2IsCameraKitEnabledResponse = {
    readonly isEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2Label = {
    readonly key: InputMaybe<Scalars["String"]["input"]>;
    readonly value: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2Lens = {
    readonly compoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly createdAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly creatorName: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMusic: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly iconUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly labels: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2Label>>>;
    readonly lensSourceInfo: InputMaybe<InputComSnapCamerakitAdminV2LenssourceModelLensSourceInfo>;
    readonly lensStatus: InputMaybe<ComSnapCamerakitAdminV2LensStatus>;
    readonly minSdkVersion: InputMaybe<Scalars["String"]["input"]>;
    readonly minWebSdkVersion: InputMaybe<Scalars["String"]["input"]>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
    readonly previewUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly previewWebpUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly removed: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly reviewStatus: InputMaybe<Scalars["String"]["input"]>;
    readonly snapcode: InputMaybe<InputComSnapCamerakitAdminV2Snapcode>;
    readonly thumbnailWebpUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly updatedAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly vendorData: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2VendorDataItem>>>;
    readonly videoUrl: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LensCompoundId = {
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceType: InputMaybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
    readonly reference: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LensInGroup = {
    readonly lens: InputMaybe<InputComSnapCamerakitAdminV2Lens>;
    readonly priority: InputMaybe<Scalars["Int"]["input"]>;
    readonly vendorData: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type InputComSnapCamerakitAdminV2LensListWithConnections = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMore: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lensesWithConnections: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LensWithConnections>>
    >;
    readonly total: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LensRequest = {
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LensWithConnections = {
    readonly connections: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2GroupLensConnection>>>;
    readonly lens: InputMaybe<InputComSnapCamerakitAdminV2Lens>;
};

export type InputComSnapCamerakitAdminV2LensesByIdsRequest = {
    readonly lensCompoundIds: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>>>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LensesRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly offset: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2ListApplicationRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2ListApplicationResponse = {
    readonly applications: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2AppInfo>>>;
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganicStatsProxyRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly request: InputMaybe<InputSnapchatReportingOrganicGetOrganicStatsRequest>;
};

export type InputComSnapCamerakitAdminV2OrganicStatsProxyResponse = {
    readonly lenses: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2Lens>>>;
    readonly response: InputMaybe<InputSnapchatReportingOrganicGetOrganicStatsResponse>;
};

export type InputComSnapCamerakitAdminV2Organization = {
    readonly accountIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly appsManagementEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly internalLabels: InputMaybe<InputComSnapCamerakitAdminV2InternalLabels>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
    readonly permissions: InputMaybe<InputComSnapCamerakitAdminV2UserPermissions>;
    readonly platformType: InputMaybe<InputComSnapCamerakitAdminV2OrganizationPlatformType>;
    readonly role: InputMaybe<ComSnapCamerakitAdminV2OrganizationUserRole>;
};

export type InputComSnapCamerakitAdminV2OrganizationAuthorizedOperationsRequest = {
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganizationAuthorizedOperationsResponse = {
    readonly orgAuthorizedOperations: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2AuthorizedOperation>>
    >;
};

export type InputComSnapCamerakitAdminV2OrganizationCreateRequest = {
    readonly orgName: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganizationCreateResponse = {
    readonly organization: InputMaybe<InputComSnapCamerakitAdminV2Organization>;
};

export type InputComSnapCamerakitAdminV2OrganizationEnableCameraKitRequest = {
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
    readonly token: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganizationEnableCameraKitResponse = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganizationListRequest = {
    readonly includeUnenabledOrgs: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganizationListResponse = {
    readonly organizations: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2Organization>>>;
};

export type InputComSnapCamerakitAdminV2OrganizationPlatformType = {
    readonly mobile: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly web: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2OrganizationSearchRequest = {
    readonly query: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2PinGroupRequest = {
    readonly groupId: InputMaybe<Scalars["String"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2PinGroupResponse = {
    readonly groupId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2PortalMe = {
    readonly bitmojiUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly hasAgreedToLatestEula: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly latestEulaId: InputMaybe<Scalars["String"]["input"]>;
    readonly latestEulaUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly snapchatUser: InputMaybe<InputComSnapCamerakitAdminV2SnapchatUser>;
};

export type InputComSnapCamerakitAdminV2PortalMeRequest = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2PortalMeResponse = {
    readonly me: InputMaybe<InputComSnapCamerakitAdminV2PortalMe>;
};

export type InputComSnapCamerakitAdminV2ReleaseConnectionBulkRequest = {
    readonly releaseRequests: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2ReleaseConnectionRequest>>
    >;
};

export type InputComSnapCamerakitAdminV2ReleaseConnectionBulkResponse = {
    readonly releaseResponses: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2ReleaseConnectionResponse>>
    >;
};

export type InputComSnapCamerakitAdminV2ReleaseConnectionRequest = {
    readonly groupId: InputMaybe<Scalars["String"]["input"]>;
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2ReleaseConnectionResponse = {
    readonly connectionId: InputMaybe<Scalars["String"]["input"]>;
    readonly groupId: InputMaybe<Scalars["String"]["input"]>;
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
};

export type InputComSnapCamerakitAdminV2RevokeCameraKitRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly principalId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2RevokeCameraKitResponse = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SaveLensRequest = {
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly vendorData: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type InputComSnapCamerakitAdminV2Schedule = {
    readonly scheduleEnd: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly scheduleStart: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly useClientTimezone: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SetAppVendorUuidOptinFlagRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly appVendorOptInEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SetAppVendorUuidOptinFlagResponse = {
    readonly appVendorOptInEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SignEulaRequest = {
    readonly eulaId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SignEulaResponse = {
    readonly me: InputMaybe<InputComSnapCamerakitAdminV2PortalMe>;
};

export type InputComSnapCamerakitAdminV2SnapKitOnboardRequest = {
    readonly appId: InputMaybe<Scalars["String"]["input"]>;
    readonly cameraKitEnabled: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly principalId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SnapKitOnboardResponse = {
    /** NOT USED */
    readonly _: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2SnapchatUser = {
    readonly displayName: InputMaybe<Scalars["String"]["input"]>;
    readonly username: InputMaybe<Scalars["String"]["input"]>;
    readonly verifiedEmail: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2Snapcode = {
    readonly deeplink: InputMaybe<Scalars["String"]["input"]>;
    readonly expiresAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly imageUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly isTemporary: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2UpdateHostedLensRequest = {
    readonly lensCompoundId: InputMaybe<InputComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly status: InputMaybe<ComSnapCamerakitAdminV2HostedLensStatus>;
};

export type InputComSnapCamerakitAdminV2UpdateHostedLensResponse = {
    readonly lens: InputMaybe<InputComSnapCamerakitAdminV2HostedLens>;
};

export type InputComSnapCamerakitAdminV2UserInfo = {
    readonly iconLink: InputMaybe<Scalars["String"]["input"]>;
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
    readonly permissions: InputMaybe<InputComSnapCamerakitAdminV2UserPermissions>;
};

export type InputComSnapCamerakitAdminV2UserPermissions = {
    readonly readGroups: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly readLensAnalytics: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly readLensSources: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly readLenses: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly scheduleLenses: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly updateGroups: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly updateLensSources: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly updateLenses: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitAdminV2VendorDataItem = {
    readonly key: InputMaybe<Scalars["String"]["input"]>;
    readonly value: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceAffectedGroupByLensSource = {
    readonly affectedNumLenses: InputMaybe<Scalars["Int"]["input"]>;
    readonly groupId: InputMaybe<Scalars["String"]["input"]>;
    readonly groupName: InputMaybe<Scalars["String"]["input"]>;
    readonly lenses: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2Lens>>>;
};

export type InputComSnapCamerakitAdminV2LenssourceAffectedGroupCursorData = {
    readonly lastGroupId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetAffectedGroupsRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly lensLimit: InputMaybe<Scalars["Int"]["input"]>;
    readonly lensSourceId: InputMaybe<Scalars["String"]["input"]>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetAffectedGroupsResponse = {
    readonly affectedGroups: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceAffectedGroupByLensSource>>
    >;
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMore: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly total: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetLensSourceListEnabledRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetLensSourceListEnabledResponse = {
    readonly lensSourceMap: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceLensSourcesMapByType>>
    >;
};

export type InputComSnapCamerakitAdminV2LenssourceGetLensSourceListRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceType: InputMaybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly query: InputMaybe<ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequestQuery>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetLensSourceListResponse = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMore: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lensSourceList: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceModelLensSource>>
    >;
    readonly total: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetSupportedLensSourceTypesRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceGetSupportedLensSourceTypesResponse = {
    readonly lensSourceTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InputComSnapCamerakitAdminV2LenssourceLensSourceDisableTask = {
    readonly createdAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly payload: InputMaybe<InputComSnapCamerakitAdminV2LenssourceLensSourceDisableTaskPayload>;
    readonly taskId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceLensSourceDisableTaskPayload = {
    readonly lensSourceList: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceModelLensSource>>
    >;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceLensSourceListCursorData = {
    readonly externalCursor: InputMaybe<Scalars["String"]["input"]>;
    readonly lastValue: InputMaybe<Scalars["String"]["input"]>;
    readonly offset: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceLensSourceUpdate = {
    readonly enabled: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly externalId: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceLensSourcesMapByType = {
    readonly lensSourceList: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceModelLensSource>>
    >;
    readonly lensSourceType: InputMaybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
};

export type InputComSnapCamerakitAdminV2LenssourceUpdateLensSourcesRequest = {
    readonly lensSourceUpdates: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceLensSourceUpdate>>
    >;
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceUpdateLensSourcesResponse = {
    readonly lensSourceList: InputMaybe<
        ReadonlyArray<InputMaybe<InputComSnapCamerakitAdminV2LenssourceModelLensSource>>
    >;
    readonly taskId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitAdminV2LenssourceModelLensSource = {
    readonly alias: InputMaybe<Scalars["String"]["input"]>;
    readonly createdAt: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly enabled: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly externalId: InputMaybe<Scalars["String"]["input"]>;
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceType: InputMaybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
    readonly owner: InputMaybe<Scalars["String"]["input"]>;
    readonly reference: InputMaybe<Scalars["String"]["input"]>;
    readonly updatedAt: InputMaybe<InputGoogleProtobufTimestamp>;
};

export type InputComSnapCamerakitAdminV2LenssourceModelLensSourceInfo = {
    readonly name: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormRequest = {
    readonly agency: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly appStoreUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly arShoppingUseCase: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly betaFeedbackOptIn: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly businessVertical: InputMaybe<ComSnapCamerakitInternalAdminV1BusinessVertical>;
    readonly cameraKitG: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly companyName: InputMaybe<Scalars["String"]["input"]>;
    readonly desiredOutcomes: InputMaybe<Scalars["String"]["input"]>;
    readonly developmentExpertiseAvailable: InputMaybe<ComSnapCamerakitInternalAdminV1DevelopmentExpertise>;
    readonly emailAddress: InputMaybe<Scalars["String"]["input"]>;
    readonly existingSnapKitDeveloper: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly existingSnapchatAdvertiser: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly fullName: InputMaybe<Scalars["String"]["input"]>;
    readonly googlePlayUrl: InputMaybe<Scalars["String"]["input"]>;
    readonly hardwareOrPhysical: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly intendedApplicationType: InputMaybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly lensCreationMethod: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly useCaseDescription: InputMaybe<Scalars["String"]["input"]>;
    readonly websiteUrl: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormResponse = {
    readonly approvalStatus: InputMaybe<ComSnapCamerakitInternalAdminV1CameraKitApprovalStatus>;
};

export type InputComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenRequest = {
    readonly organizationId: InputMaybe<Scalars["String"]["input"]>;
    readonly token: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenResponse = {
    readonly cameraKitMobileAppAccess: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly cameraKitWebAppAccess: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly consumeTokenStatus: InputMaybe<ComSnapCamerakitInternalAdminV1ConsumeTokenStatus>;
};

export type InputComSnapCamerakitInternalAdminV1InternalLabels = {
    readonly firstParty: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly live: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly managed: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ListTokenRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly endDateMillis: InputMaybe<Scalars["Long"]["input"]>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly startDateMillis: InputMaybe<Scalars["Long"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ListTokenResponse = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly tokens: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type InputComSnapCamerakitInternalAdminV1NotifyEmailRequest = {
    readonly formIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly notifyEmails: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly platformType: InputMaybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly templateId: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1NotifyEmailResponse = {
    readonly successes: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type InputComSnapCamerakitInternalAdminV1OnboardingToken = {
    readonly cameraKitMobileAppAccess: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly cameraKitWebAppAccess: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly consumedTimeMillis: InputMaybe<Scalars["Long"]["input"]>;
    readonly consumingOrganization: InputMaybe<Scalars["String"]["input"]>;
    readonly createdTimeMillis: InputMaybe<Scalars["Long"]["input"]>;
    readonly firstVerifiedTimeMillis: InputMaybe<Scalars["Long"]["input"]>;
    readonly isRevoked: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly requestingEmail: InputMaybe<Scalars["String"]["input"]>;
    readonly tokenValue: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1Organization = {
    readonly id: InputMaybe<Scalars["String"]["input"]>;
    readonly internalLabels: InputMaybe<InputComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly name: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1RevokeTokenRequest = {
    readonly token: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1RevokeTokenResponse = {
    readonly tokenRevoked: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1SearchOrganizationRequest = {
    readonly query: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1SearchOrganizationResponse = {
    readonly organizations: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitInternalAdminV1Organization>>>;
};

export type InputComSnapCamerakitInternalAdminV1SearchTokenRequest = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly requestingEmail: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1SearchTokenResponse = {
    readonly cursor: InputMaybe<Scalars["String"]["input"]>;
    readonly tokens: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type InputComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsRequest = {
    readonly internalLabels: InputMaybe<InputComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly orgId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsResponse = {
    readonly internalLabels: InputMaybe<InputComSnapCamerakitInternalAdminV1InternalLabels>;
};

export type InputComSnapCamerakitInternalAdminV1ValidateOnboardingTokenRequest = {
    readonly token: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ValidateOnboardingTokenResponse = {
    readonly onboardingTokenStatus: InputMaybe<ComSnapCamerakitInternalAdminV1ValidateTokenStatus>;
};

export type InputGoogleProtobufTimestamp = {
    readonly nanos: InputMaybe<Scalars["Int"]["input"]>;
    readonly seconds: InputMaybe<Scalars["Long"]["input"]>;
};

export type InputSnapchatReportingOrganicGetOrganicStatsRequest = {
    readonly assetId: InputMaybe<Scalars["String"]["input"]>;
    readonly assetType: InputMaybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownAssetType: InputMaybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly conversionReportTime: InputMaybe<SnapchatReportingOrganicConversionReportTime>;
    readonly conversionSourceType: InputMaybe<SnapchatReportingOrganicConversionSourceType>;
    readonly conversionSwipeUpWindow: InputMaybe<SnapchatReportingOrganicConversionSwipeUpWindow>;
    readonly conversionViewWindow: InputMaybe<SnapchatReportingOrganicConversionViewWindow>;
    readonly endTime: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly fields: InputMaybe<ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsField>>>;
    readonly granularity: InputMaybe<SnapchatReportingOrganicGranularity>;
    readonly isTest: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly limit: InputMaybe<Scalars["Int"]["input"]>;
    readonly offset: InputMaybe<Scalars["Int"]["input"]>;
    readonly placeCollectionId: InputMaybe<Scalars["String"]["input"]>;
    readonly profileId: InputMaybe<Scalars["String"]["input"]>;
    readonly publisherId: InputMaybe<Scalars["String"]["input"]>;
    readonly requestId: InputMaybe<Scalars["String"]["input"]>;
    readonly requestType: InputMaybe<SnapchatReportingOrganicRequestType>;
    readonly sortBy: InputMaybe<SnapchatReportingOrganicMetricField>;
    readonly sortByDimension: InputMaybe<SnapchatReportingOrganicUserDimension>;
    readonly sortByDimensionBreakdowns: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
    readonly sortDirection: InputMaybe<SnapchatReportingOrganicSortDirection>;
    readonly startTime: InputMaybe<InputGoogleProtobufTimestamp>;
    readonly topDimensionLimit: InputMaybe<Scalars["Int"]["input"]>;
    readonly userId: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapchatReportingOrganicGetOrganicStatsResponse = {
    readonly responseEntry: InputMaybe<
        ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsResponseEntry>>
    >;
};

export type InputSnapchatReportingOrganicOrganicStat = {
    readonly dimensionBreakdown: InputMaybe<Scalars["String"]["input"]>;
    readonly percentageValue: InputMaybe<Scalars["Float"]["input"]>;
    readonly value: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapchatReportingOrganicOrganicStatsField = {
    readonly fieldName: InputMaybe<SnapchatReportingOrganicMetricField>;
    readonly reportDimension: InputMaybe<SnapchatReportingOrganicUserDimension>;
    readonly reportDimensionFilters: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type InputSnapchatReportingOrganicOrganicStatsResponseDimensionEntry = {
    readonly field: InputMaybe<InputSnapchatReportingOrganicOrganicStatsField>;
    readonly stats: InputMaybe<ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStat>>>;
};

export type InputSnapchatReportingOrganicOrganicStatsResponseEntry = {
    readonly assetId: InputMaybe<Scalars["String"]["input"]>;
    readonly assetType: InputMaybe<SnapchatReportingOrganicAssetType>;
    readonly statsResponseTimeEntry: InputMaybe<
        ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsResponseTimeEntry>>
    >;
};

export type InputSnapchatReportingOrganicOrganicStatsResponseTimeEntry = {
    readonly stats: InputMaybe<
        ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsResponseDimensionEntry>>
    >;
    readonly timestamp: InputMaybe<InputGoogleProtobufTimestamp>;
};

export type MutationType = {
    readonly __typename?: "MutationType";
    readonly createApplication: Maybe<ComSnapCamerakitAdminV2CreateApplicationResponse>;
    readonly createConnectionBulk: Maybe<ComSnapCamerakitAdminV2CreateConnectionBulkResponse>;
    readonly createOrganization: Maybe<ComSnapCamerakitAdminV2OrganizationCreateResponse>;
    readonly createPin: Maybe<ComSnapCamerakitAdminV2PinGroupResponse>;
    readonly createVersion: Maybe<ComSnapCamerakitAdminV2CreateVersionResponse>;
    readonly enableCameraKitFeature: Maybe<ComSnapCamerakitAdminV2EnableCameraKitFeatureResponse>;
    readonly enableCameraKitOrganization: Maybe<ComSnapCamerakitAdminV2OrganizationEnableCameraKitResponse>;
    readonly generateApiToken: Maybe<ComSnapCamerakitAdminV2GenerateApiTokenResponse>;
    readonly isUnauthorized: Maybe<Scalars["Boolean"]["output"]>;
    readonly releaseConnectionBulk: Maybe<ComSnapCamerakitAdminV2ReleaseConnectionBulkResponse>;
    readonly removePin: Maybe<ComSnapCamerakitAdminV2PinGroupResponse>;
    readonly saveGroupV2: Maybe<ComSnapCamerakitAdminV2GroupWithConnections>;
    readonly saveLensV2: Maybe<ComSnapCamerakitAdminV2LensWithConnections>;
    readonly selectedOrganization: Maybe<ComSnapCamerakitAdminV2Organization>;
    readonly signEULA: Maybe<ComSnapCamerakitAdminV2SignEulaResponse>;
    readonly updateLensSources: Maybe<ComSnapCamerakitAdminV2LenssourceUpdateLensSourcesResponse>;
};

export type MutationTypeCreateApplicationArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2CreateApplicationRequest>;
};

export type MutationTypeCreateConnectionBulkArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2CreateConnectionBulkRequest>;
};

export type MutationTypeCreateOrganizationArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2OrganizationCreateRequest>;
};

export type MutationTypeCreatePinArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2PinGroupRequest>;
};

export type MutationTypeCreateVersionArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2CreateVersionRequest>;
};

export type MutationTypeEnableCameraKitFeatureArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2EnableCameraKitFeatureRequest>;
};

export type MutationTypeEnableCameraKitOrganizationArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2OrganizationEnableCameraKitRequest>;
};

export type MutationTypeGenerateApiTokenArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GenerateApiTokenRequest>;
};

export type MutationTypeReleaseConnectionBulkArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2ReleaseConnectionBulkRequest>;
};

export type MutationTypeRemovePinArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2PinGroupRequest>;
};

export type MutationTypeSaveGroupV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GroupSaveRequest>;
};

export type MutationTypeSaveLensV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2SaveLensRequest>;
};

export type MutationTypeSignEulaArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2SignEulaRequest>;
};

export type MutationTypeUpdateLensSourcesArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LenssourceUpdateLensSourcesRequest>;
};

export type QueryType = {
    readonly __typename?: "QueryType";
    readonly getAdAccounts: Maybe<ComSnapCamerakitAdminV2GetAdAccountsResponse>;
    readonly getAffectedGroups: Maybe<ComSnapCamerakitAdminV2LenssourceGetAffectedGroupsResponse>;
    readonly getAppInfo: Maybe<ComSnapCamerakitAdminV2GetApplicationInfoResponse>;
    readonly getAppList: Maybe<ReadonlyArray<ComSnapCamerakitAdminV2AppInfo>>;
    readonly getGroupListV2: Maybe<ComSnapCamerakitAdminV2GroupListWithConnections>;
    readonly getGroupV2: Maybe<ComSnapCamerakitAdminV2GroupWithConnections>;
    readonly getLensListV2: Maybe<ComSnapCamerakitAdminV2LensListWithConnections>;
    readonly getLensSourceList: Maybe<ComSnapCamerakitAdminV2LenssourceGetLensSourceListResponse>;
    readonly getLensSourceListEnabled: Maybe<ComSnapCamerakitAdminV2LenssourceGetLensSourceListEnabledResponse>;
    readonly getLensV2: Maybe<ComSnapCamerakitAdminV2LensWithConnections>;
    readonly getOrgLensMarketplaceSubscription: Maybe<ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionResponse>;
    readonly getOrganicStats: Maybe<SnapchatReportingOrganicGetOrganicStatsResponse>;
    readonly getOrganicStatsV2: Maybe<ComSnapCamerakitAdminV2OrganicStatsProxyResponse>;
    readonly getOrganizations: Maybe<ComSnapCamerakitAdminV2OrganizationListResponse>;
    readonly getSupportedLensSourceTypes: Maybe<ComSnapCamerakitAdminV2LenssourceGetSupportedLensSourceTypesResponse>;
    readonly getUserInfo: Maybe<ComSnapCamerakitAdminV2UserInfo>;
    readonly isCameraKitEnabled: Maybe<ComSnapCamerakitAdminV2IsCameraKitEnabledOrganizationResponse>;
    readonly isUnauthorized: Maybe<Scalars["Boolean"]["output"]>;
    readonly me: Maybe<ComSnapCamerakitAdminV2PortalMeResponse>;
    readonly searchOrganizations: Maybe<ComSnapCamerakitAdminV2OrganizationListResponse>;
    readonly selectedOrganization: Maybe<ComSnapCamerakitAdminV2Organization>;
    readonly validateOnboardingToken: Maybe<ComSnapCamerakitInternalAdminV1ValidateOnboardingTokenResponse>;
};

export type QueryTypeGetAdAccountsArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GetAdAccountsRequest>;
};

export type QueryTypeGetAffectedGroupsArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LenssourceGetAffectedGroupsRequest>;
};

export type QueryTypeGetAppInfoArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GetApplicationInfoRequest>;
};

export type QueryTypeGetAppListArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2ListApplicationRequest>;
};

export type QueryTypeGetGroupListV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GroupListRequest>;
};

export type QueryTypeGetGroupV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GroupRequest>;
};

export type QueryTypeGetLensListV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LensesRequest>;
};

export type QueryTypeGetLensSourceListArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LenssourceGetLensSourceListRequest>;
};

export type QueryTypeGetLensSourceListEnabledArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LenssourceGetLensSourceListEnabledRequest>;
};

export type QueryTypeGetLensV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LensRequest>;
};

export type QueryTypeGetOrgLensMarketplaceSubscriptionArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionRequest>;
};

export type QueryTypeGetOrganicStatsArgs = {
    input: InputMaybe<InputSnapchatReportingOrganicGetOrganicStatsRequest>;
};

export type QueryTypeGetOrganicStatsV2Args = {
    input: InputMaybe<InputComSnapCamerakitAdminV2OrganicStatsProxyRequest>;
};

export type QueryTypeGetOrganizationsArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2OrganizationListRequest>;
};

export type QueryTypeGetSupportedLensSourceTypesArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2LenssourceGetSupportedLensSourceTypesRequest>;
};

export type QueryTypeGetUserInfoArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2GetUserInfoRequest>;
};

export type QueryTypeIsCameraKitEnabledArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2IsCameraKitEnabledOrganizationRequest>;
};

export type QueryTypeMeArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2PortalMeRequest>;
};

export type QueryTypeSearchOrganizationsArgs = {
    input: InputMaybe<InputComSnapCamerakitAdminV2OrganizationSearchRequest>;
};

export type QueryTypeValidateOnboardingTokenArgs = {
    input: InputMaybe<InputComSnapCamerakitInternalAdminV1ValidateOnboardingTokenRequest>;
};

export type ComSnapCamerakitAdminV2AdAccount = {
    readonly __typename?: "com_snap_camerakit_admin_v2_AdAccount";
    readonly id: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2ApiToken = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ApiToken";
    readonly createdTsMillis: Maybe<Scalars["Float"]["output"]>;
    readonly stage: Maybe<ComSnapCamerakitAdminV2Stage>;
    readonly token: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2AppInfo = {
    readonly __typename?: "com_snap_camerakit_admin_v2_AppInfo";
    readonly apiTokens: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2ApiToken>>>;
    readonly appAuthorizedOperations: Maybe<ReadonlyArray<ComSnapCamerakitAdminV2AuthorizedOperation>>;
    readonly appIconUrl: Maybe<Scalars["String"]["output"]>;
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly appVendorUuidOptinFlag: Maybe<Scalars["Boolean"]["output"]>;
    readonly internalAppName: Maybe<Scalars["String"]["output"]>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
    readonly platformType: Maybe<ComSnapCamerakitAdminV2PlatformType>;
    readonly prodLiveVersion: Maybe<Scalars["Int"]["output"]>;
    readonly stagingLiveVersion: Maybe<Scalars["Int"]["output"]>;
    readonly versions: Maybe<ReadonlyArray<ComSnapCamerakitAdminV2AppVersion>>;
};

export type ComSnapCamerakitAdminV2AppInput = {
    readonly __typename?: "com_snap_camerakit_admin_v2_AppInput";
    readonly internalAppName: Maybe<Scalars["String"]["output"]>;
    readonly platformType: Maybe<ComSnapCamerakitAdminV2PlatformType>;
};

export type ComSnapCamerakitAdminV2AppVersion = {
    readonly __typename?: "com_snap_camerakit_admin_v2_AppVersion";
    readonly appDescription: Maybe<Scalars["String"]["output"]>;
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly appName: Maybe<Scalars["String"]["output"]>;
    readonly features: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2Feature>>>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
    readonly reviewState: Maybe<ComSnapCamerakitAdminV2ReviewState>;
    readonly version: Maybe<Scalars["Int"]["output"]>;
    readonly versionName: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2ApplicationAuthorizedOperationsRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ApplicationAuthorizedOperationsRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2ApplicationAuthorizedOperationsResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ApplicationAuthorizedOperationsResponse";
    readonly appAuthorizedOperations: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2AuthorizedOperation>>>;
};

export enum ComSnapCamerakitAdminV2AuthOperation {
    AuthOperationOrganizations = "AUTH_OPERATION_ORGANIZATIONS",
    AuthOperationProjects = "AUTH_OPERATION_PROJECTS",
    AuthOperationSnapKitApps = "AUTH_OPERATION_SNAP_KIT_APPS",
    AuthOperationUnset = "AUTH_OPERATION_UNSET",
}

export type ComSnapCamerakitAdminV2AuthorizedOperation = {
    readonly __typename?: "com_snap_camerakit_admin_v2_AuthorizedOperation";
    readonly authOperation: Maybe<ComSnapCamerakitAdminV2AuthOperation>;
    readonly authOperationTypes: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
};

export type ComSnapCamerakitAdminV2CreateApplicationRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateApplicationRequest";
    readonly appInfo: Maybe<ComSnapCamerakitAdminV2AppInput>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2CreateApplicationResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateApplicationResponse";
    readonly appInfo: Maybe<ComSnapCamerakitAdminV2AppInfo>;
};

export type ComSnapCamerakitAdminV2CreateConnectionBulkRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateConnectionBulkRequest";
    readonly createRequests: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2CreateConnectionRequest>>>;
};

export type ComSnapCamerakitAdminV2CreateConnectionBulkResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateConnectionBulkResponse";
    readonly connections: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2GroupLensConnection>>>;
};

export type ComSnapCamerakitAdminV2CreateConnectionRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateConnectionRequest";
    readonly groupId: Maybe<Scalars["String"]["output"]>;
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly priority: Maybe<Scalars["Int"]["output"]>;
    readonly schedule: Maybe<ComSnapCamerakitAdminV2Schedule>;
    readonly vendorData: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type ComSnapCamerakitAdminV2CreateVersionRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateVersionRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly appVersionName: Maybe<Scalars["String"]["output"]>;
    readonly sourceVersion: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2CreateVersionResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_CreateVersionResponse";
    readonly appVersion: Maybe<ComSnapCamerakitAdminV2AppVersion>;
};

export type ComSnapCamerakitAdminV2DeleteHostedLensRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_DeleteHostedLensRequest";
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2DeleteHostedLensResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_DeleteHostedLensResponse";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2EnableCameraKitFeatureRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_EnableCameraKitFeatureRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly sourceVersion: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2EnableCameraKitFeatureResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_EnableCameraKitFeatureResponse";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2Feature = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Feature";
    readonly enabled: Maybe<Scalars["Boolean"]["output"]>;
    readonly featureScopeName: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GenerateApiTokenRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GenerateApiTokenRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly stage: Maybe<ComSnapCamerakitAdminV2Stage>;
};

export type ComSnapCamerakitAdminV2GenerateApiTokenResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GenerateApiTokenResponse";
    readonly apiToken: Maybe<ComSnapCamerakitAdminV2ApiToken>;
};

export type ComSnapCamerakitAdminV2GenerateHostedLensRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GenerateHostedLensRequest";
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GenerateHostedLensResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GenerateHostedLensResponse";
    readonly lens: Maybe<ComSnapCamerakitAdminV2HostedLens>;
};

export type ComSnapCamerakitAdminV2GetAdAccountsRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetAdAccountsRequest";
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetAdAccountsResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetAdAccountsResponse";
    readonly adAccounts: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2AdAccount>>>;
};

export type ComSnapCamerakitAdminV2GetAppVendorUuidOptinFlagRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetAppVendorUuidOptinFlagRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetAppVendorUuidOptinFlagResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetAppVendorUuidOptinFlagResponse";
    readonly appVendorOptInEnabled: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetApplicationInfoRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetApplicationInfoRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetApplicationInfoResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetApplicationInfoResponse";
    readonly application: Maybe<ComSnapCamerakitAdminV2AppInfo>;
};

export type ComSnapCamerakitAdminV2GetHostedLensListRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetHostedLensListRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetHostedLensListResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetHostedLensListResponse";
    readonly lenses: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2HostedLens>>>;
};

export type ComSnapCamerakitAdminV2GetHostedLensRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetHostedLensRequest";
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetHostedLensResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetHostedLensResponse";
    readonly lens: Maybe<ComSnapCamerakitAdminV2HostedLens>;
};

export type ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetOrgLensMarketplaceSubscriptionRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetOrgLensMarketplaceSubscriptionResponse";
    readonly hasSubscription: Maybe<Scalars["Boolean"]["output"]>;
    readonly subscriptionExpiry: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetUserInfoRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetUserInfoRequest";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetVersionListRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetVersionListRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GetVersionListResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GetVersionListResponse";
    readonly versions: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2AppVersion>>>;
};

export type ComSnapCamerakitAdminV2Group = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Group";
    readonly createdAt: Maybe<GoogleProtobufTimestamp>;
    readonly description: Maybe<Scalars["String"]["output"]>;
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly isPinned: Maybe<Scalars["Boolean"]["output"]>;
    readonly lenses: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LensInGroup>>>;
    readonly name: Maybe<Scalars["String"]["output"]>;
    readonly readOnly: Maybe<Scalars["Boolean"]["output"]>;
    readonly status: Maybe<ComSnapCamerakitAdminV2GroupStatus>;
    readonly totalNumLenses: Maybe<Scalars["Int"]["output"]>;
    readonly updatedAt: Maybe<GoogleProtobufTimestamp>;
};

export type ComSnapCamerakitAdminV2GroupLensConnection = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GroupLensConnection";
    readonly connectionId: Maybe<Scalars["String"]["output"]>;
    readonly group: Maybe<ComSnapCamerakitAdminV2Group>;
    readonly lens: Maybe<ComSnapCamerakitAdminV2Lens>;
    readonly priority: Maybe<Scalars["Int"]["output"]>;
    readonly schedule: Maybe<ComSnapCamerakitAdminV2Schedule>;
    readonly vendorData: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type ComSnapCamerakitAdminV2GroupListRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GroupListRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly lensLimit: Maybe<Scalars["Int"]["output"]>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly offset: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly query: Maybe<ComSnapCamerakitAdminV2GroupListRequestQuery>;
};

export enum ComSnapCamerakitAdminV2GroupListRequestQuery {
    All = "ALL",
    OnlyActive = "ONLY_ACTIVE",
}

export type ComSnapCamerakitAdminV2GroupListWithConnections = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GroupListWithConnections";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly groupsWithConnections: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2GroupWithConnections>>>;
    readonly hasMore: Maybe<Scalars["Boolean"]["output"]>;
    readonly total: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2GroupRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GroupRequest";
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly lensLimit: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2GroupSaveRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GroupSaveRequest";
    readonly description: Maybe<Scalars["String"]["output"]>;
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly lens: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LensInGroup>>>;
    readonly name: Maybe<Scalars["String"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly status: Maybe<ComSnapCamerakitAdminV2GroupStatus>;
};

export type ComSnapCamerakitAdminV2GroupWithConnections = {
    readonly __typename?: "com_snap_camerakit_admin_v2_GroupWithConnections";
    readonly connections: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2GroupLensConnection>>>;
    readonly group: Maybe<ComSnapCamerakitAdminV2Group>;
};

export enum ComSnapCamerakitAdminV2GroupStatus {
    Active = "ACTIVE",
    Archived = "ARCHIVED",
}

export type ComSnapCamerakitAdminV2HostedLens = {
    readonly __typename?: "com_snap_camerakit_admin_v2_HostedLens";
    readonly compoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly createdAt: Maybe<GoogleProtobufTimestamp>;
    readonly createdBy: Maybe<Scalars["String"]["output"]>;
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly link: Maybe<Scalars["String"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly reference: Maybe<Scalars["String"]["output"]>;
    readonly status: Maybe<ComSnapCamerakitAdminV2HostedLensStatus>;
    readonly updatedAt: Maybe<GoogleProtobufTimestamp>;
};

export enum ComSnapCamerakitAdminV2HostedLensStatus {
    HostedLensStatusDraft = "HOSTED_LENS_STATUS_DRAFT",
    HostedLensStatusPublished = "HOSTED_LENS_STATUS_PUBLISHED",
    HostedLensStatusUnpublished = "HOSTED_LENS_STATUS_UNPUBLISHED",
    HostedLensStatusUnset = "HOSTED_LENS_STATUS_UNSET",
}

export type ComSnapCamerakitAdminV2InternalLabels = {
    readonly __typename?: "com_snap_camerakit_admin_v2_InternalLabels";
    readonly firstParty: Maybe<Scalars["Boolean"]["output"]>;
    readonly live: Maybe<Scalars["Boolean"]["output"]>;
    readonly managed: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2IsCameraKitEnabledOrganizationRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_IsCameraKitEnabledOrganizationRequest";
    readonly applicationType: Maybe<ComSnapCamerakitAdminV2PlatformType>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2IsCameraKitEnabledOrganizationResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_IsCameraKitEnabledOrganizationResponse";
    readonly isEnabled: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2IsCameraKitEnabledRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_IsCameraKitEnabledRequest";
    readonly applicationType: Maybe<ComSnapCamerakitAdminV2PlatformType>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2IsCameraKitEnabledResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_IsCameraKitEnabledResponse";
    readonly isEnabled: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2Label = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Label";
    readonly key: Maybe<Scalars["String"]["output"]>;
    readonly value: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2Lens = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Lens";
    readonly compoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly createdAt: Maybe<GoogleProtobufTimestamp>;
    readonly creatorName: Maybe<Scalars["String"]["output"]>;
    readonly hasMusic: Maybe<Scalars["Boolean"]["output"]>;
    readonly iconUrl: Maybe<Scalars["String"]["output"]>;
    readonly labels: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2Label>>>;
    readonly lensSourceInfo: Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceInfo>;
    readonly lensStatus: Maybe<ComSnapCamerakitAdminV2LensStatus>;
    readonly minSdkVersion: Maybe<Scalars["String"]["output"]>;
    readonly minWebSdkVersion: Maybe<Scalars["String"]["output"]>;
    readonly name: Maybe<Scalars["String"]["output"]>;
    readonly previewUrl: Maybe<Scalars["String"]["output"]>;
    readonly previewWebpUrl: Maybe<Scalars["String"]["output"]>;
    readonly removed: Maybe<Scalars["Boolean"]["output"]>;
    /** @deprecated deprecated in proto */
    readonly reviewStatus: Maybe<Scalars["String"]["output"]>;
    readonly snapcode: Maybe<ComSnapCamerakitAdminV2Snapcode>;
    readonly thumbnailWebpUrl: Maybe<Scalars["String"]["output"]>;
    readonly updatedAt: Maybe<GoogleProtobufTimestamp>;
    readonly vendorData: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2VendorDataItem>>>;
    readonly videoUrl: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LensCompoundId = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensCompoundId";
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceType: Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
    readonly reference: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LensInGroup = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensInGroup";
    readonly lens: Maybe<ComSnapCamerakitAdminV2Lens>;
    readonly priority: Maybe<Scalars["Int"]["output"]>;
    readonly vendorData: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type ComSnapCamerakitAdminV2LensListWithConnections = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensListWithConnections";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly hasMore: Maybe<Scalars["Boolean"]["output"]>;
    readonly lensesWithConnections: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LensWithConnections>>>;
    readonly total: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2LensRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensRequest";
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export enum ComSnapCamerakitAdminV2LensStatus {
    LensStatusAvailable = "LENS_STATUS_AVAILABLE",
    LensStatusAwaitingProductTagging = "LENS_STATUS_AWAITING_PRODUCT_TAGGING",
    LensStatusFinalized = "LENS_STATUS_FINALIZED",
    LensStatusFinalizing = "LENS_STATUS_FINALIZING",
    LensStatusHidden = "LENS_STATUS_HIDDEN",
    LensStatusInvalid = "LENS_STATUS_INVALID",
    LensStatusInReview = "LENS_STATUS_IN_REVIEW",
    LensStatusLive = "LENS_STATUS_LIVE",
    LensStatusNotPublishedToSnapchat = "LENS_STATUS_NOT_PUBLISHED_TO_SNAPCHAT",
    LensStatusOffline = "LENS_STATUS_OFFLINE",
    LensStatusProcessing = "LENS_STATUS_PROCESSING",
    LensStatusReady = "LENS_STATUS_READY",
    LensStatusRejected = "LENS_STATUS_REJECTED",
    LensStatusUnset = "LENS_STATUS_UNSET",
}

export type ComSnapCamerakitAdminV2LensWithConnections = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensWithConnections";
    readonly connections: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2GroupLensConnection>>>;
    readonly lens: Maybe<ComSnapCamerakitAdminV2Lens>;
};

export type ComSnapCamerakitAdminV2LensesByIdsRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensesByIdsRequest";
    readonly lensCompoundIds: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LensCompoundId>>>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LensesRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_LensesRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceIds: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly offset: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2ListApplicationRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ListApplicationRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2ListApplicationResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ListApplicationResponse";
    readonly applications: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2AppInfo>>>;
    readonly cursor: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganicStatsProxyRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganicStatsProxyRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly request: Maybe<SnapchatReportingOrganicGetOrganicStatsRequest>;
};

export type ComSnapCamerakitAdminV2OrganicStatsProxyResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganicStatsProxyResponse";
    readonly lenses: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2Lens>>>;
    readonly response: Maybe<SnapchatReportingOrganicGetOrganicStatsResponse>;
};

export type ComSnapCamerakitAdminV2Organization = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Organization";
    readonly accountIds: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly apps: Maybe<ReadonlyArray<ComSnapCamerakitAdminV2AppInfo>>;
    readonly appsManagementEnabled: Maybe<Scalars["Boolean"]["output"]>;
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly internalLabels: Maybe<ComSnapCamerakitAdminV2InternalLabels>;
    readonly name: Maybe<Scalars["String"]["output"]>;
    readonly orgAuthorizedOperations: Maybe<ReadonlyArray<ComSnapCamerakitAdminV2AuthorizedOperation>>;
    readonly permissions: Maybe<ComSnapCamerakitAdminV2UserPermissions>;
    readonly platformType: Maybe<ComSnapCamerakitAdminV2OrganizationPlatformType>;
    readonly role: Maybe<ComSnapCamerakitAdminV2OrganizationUserRole>;
};

export type ComSnapCamerakitAdminV2OrganizationAuthorizedOperationsRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationAuthorizedOperationsRequest";
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganizationAuthorizedOperationsResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationAuthorizedOperationsResponse";
    readonly orgAuthorizedOperations: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2AuthorizedOperation>>>;
};

export type ComSnapCamerakitAdminV2OrganizationCreateRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationCreateRequest";
    readonly orgName: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganizationCreateResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationCreateResponse";
    readonly organization: Maybe<ComSnapCamerakitAdminV2Organization>;
};

export type ComSnapCamerakitAdminV2OrganizationEnableCameraKitRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationEnableCameraKitRequest";
    readonly orgId: Maybe<Scalars["String"]["output"]>;
    readonly token: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganizationEnableCameraKitResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationEnableCameraKitResponse";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganizationListRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationListRequest";
    readonly includeUnenabledOrgs: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganizationListResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationListResponse";
    readonly organizations: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2Organization>>>;
};

export type ComSnapCamerakitAdminV2OrganizationPlatformType = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationPlatformType";
    readonly mobile: Maybe<Scalars["Boolean"]["output"]>;
    readonly web: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2OrganizationSearchRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_OrganizationSearchRequest";
    readonly query: Maybe<Scalars["String"]["output"]>;
};

export enum ComSnapCamerakitAdminV2OrganizationUserRole {
    Admin = "ADMIN",
    Member = "MEMBER",
    Unset = "UNSET",
}

export type ComSnapCamerakitAdminV2PinGroupRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_PinGroupRequest";
    readonly groupId: Maybe<Scalars["String"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2PinGroupResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_PinGroupResponse";
    readonly groupId: Maybe<Scalars["String"]["output"]>;
};

export enum ComSnapCamerakitAdminV2PlatformType {
    PlatformTypeMobile = "PLATFORM_TYPE_MOBILE",
    PlatformTypeNone = "PLATFORM_TYPE_NONE",
    PlatformTypeUnset = "PLATFORM_TYPE_UNSET",
    PlatformTypeWeb = "PLATFORM_TYPE_WEB",
}

export type ComSnapCamerakitAdminV2PortalMe = {
    readonly __typename?: "com_snap_camerakit_admin_v2_PortalMe";
    readonly bitmojiUrl: Maybe<Scalars["String"]["output"]>;
    readonly hasAgreedToLatestEula: Maybe<Scalars["Boolean"]["output"]>;
    readonly latestEulaId: Maybe<Scalars["String"]["output"]>;
    readonly latestEulaUrl: Maybe<Scalars["String"]["output"]>;
    readonly snapchatUser: Maybe<ComSnapCamerakitAdminV2SnapchatUser>;
};

export type ComSnapCamerakitAdminV2PortalMeRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_PortalMeRequest";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2PortalMeResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_PortalMeResponse";
    readonly me: Maybe<ComSnapCamerakitAdminV2PortalMe>;
};

export type ComSnapCamerakitAdminV2ReleaseConnectionBulkRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ReleaseConnectionBulkRequest";
    readonly releaseRequests: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2ReleaseConnectionRequest>>>;
};

export type ComSnapCamerakitAdminV2ReleaseConnectionBulkResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ReleaseConnectionBulkResponse";
    readonly releaseResponses: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2ReleaseConnectionResponse>>>;
};

export type ComSnapCamerakitAdminV2ReleaseConnectionRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ReleaseConnectionRequest";
    readonly groupId: Maybe<Scalars["String"]["output"]>;
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2ReleaseConnectionResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_ReleaseConnectionResponse";
    readonly connectionId: Maybe<Scalars["String"]["output"]>;
    readonly groupId: Maybe<Scalars["String"]["output"]>;
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
};

export enum ComSnapCamerakitAdminV2ReviewState {
    ReviewStateApproved = "REVIEW_STATE_APPROVED",
    ReviewStateInReview = "REVIEW_STATE_IN_REVIEW",
    ReviewStatePreReview = "REVIEW_STATE_PRE_REVIEW",
    ReviewStateRejected = "REVIEW_STATE_REJECTED",
    ReviewStateUnset = "REVIEW_STATE_UNSET",
}

export type ComSnapCamerakitAdminV2RevokeCameraKitRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_RevokeCameraKitRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly principalId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2RevokeCameraKitResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_RevokeCameraKitResponse";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2SaveLensRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SaveLensRequest";
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly vendorData: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2VendorDataItem>>>;
};

export type ComSnapCamerakitAdminV2Schedule = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Schedule";
    readonly scheduleEnd: Maybe<GoogleProtobufTimestamp>;
    readonly scheduleStart: Maybe<GoogleProtobufTimestamp>;
    readonly useClientTimezone: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2SetAppVendorUuidOptinFlagRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SetAppVendorUuidOptinFlagRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly appVendorOptInEnabled: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2SetAppVendorUuidOptinFlagResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SetAppVendorUuidOptinFlagResponse";
    readonly appVendorOptInEnabled: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2SignEulaRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SignEULARequest";
    readonly eulaId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2SignEulaResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SignEULAResponse";
    readonly me: Maybe<ComSnapCamerakitAdminV2PortalMe>;
};

export type ComSnapCamerakitAdminV2SnapKitOnboardRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SnapKitOnboardRequest";
    readonly appId: Maybe<Scalars["String"]["output"]>;
    readonly cameraKitEnabled: Maybe<Scalars["Boolean"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly principalId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2SnapKitOnboardResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SnapKitOnboardResponse";
    readonly _: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2SnapchatUser = {
    readonly __typename?: "com_snap_camerakit_admin_v2_SnapchatUser";
    readonly displayName: Maybe<Scalars["String"]["output"]>;
    readonly username: Maybe<Scalars["String"]["output"]>;
    readonly verifiedEmail: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2Snapcode = {
    readonly __typename?: "com_snap_camerakit_admin_v2_Snapcode";
    readonly deeplink: Maybe<Scalars["String"]["output"]>;
    readonly expiresAt: Maybe<GoogleProtobufTimestamp>;
    readonly imageUrl: Maybe<Scalars["String"]["output"]>;
    readonly isTemporary: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ComSnapCamerakitAdminV2Stage {
    StageNone = "STAGE_NONE",
    StageProd = "STAGE_PROD",
    StageStaging = "STAGE_STAGING",
    StageUnset = "STAGE_UNSET",
}

export type ComSnapCamerakitAdminV2UpdateHostedLensRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_UpdateHostedLensRequest";
    readonly lensCompoundId: Maybe<ComSnapCamerakitAdminV2LensCompoundId>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly status: Maybe<ComSnapCamerakitAdminV2HostedLensStatus>;
};

export type ComSnapCamerakitAdminV2UpdateHostedLensResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_UpdateHostedLensResponse";
    readonly lens: Maybe<ComSnapCamerakitAdminV2HostedLens>;
};

export type ComSnapCamerakitAdminV2UserInfo = {
    readonly __typename?: "com_snap_camerakit_admin_v2_UserInfo";
    readonly iconLink: Maybe<Scalars["String"]["output"]>;
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly name: Maybe<Scalars["String"]["output"]>;
    readonly permissions: Maybe<ComSnapCamerakitAdminV2UserPermissions>;
};

export type ComSnapCamerakitAdminV2UserPermissions = {
    readonly __typename?: "com_snap_camerakit_admin_v2_UserPermissions";
    readonly readGroups: Maybe<Scalars["Boolean"]["output"]>;
    readonly readLensAnalytics: Maybe<Scalars["Boolean"]["output"]>;
    readonly readLensSources: Maybe<Scalars["Boolean"]["output"]>;
    readonly readLenses: Maybe<Scalars["Boolean"]["output"]>;
    readonly scheduleLenses: Maybe<Scalars["Boolean"]["output"]>;
    readonly updateGroups: Maybe<Scalars["Boolean"]["output"]>;
    readonly updateLensSources: Maybe<Scalars["Boolean"]["output"]>;
    readonly updateLenses: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitAdminV2VendorDataItem = {
    readonly __typename?: "com_snap_camerakit_admin_v2_VendorDataItem";
    readonly key: Maybe<Scalars["String"]["output"]>;
    readonly value: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceAffectedGroupByLensSource = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_AffectedGroupByLensSource";
    readonly affectedNumLenses: Maybe<Scalars["Int"]["output"]>;
    readonly groupId: Maybe<Scalars["String"]["output"]>;
    readonly groupName: Maybe<Scalars["String"]["output"]>;
    readonly lenses: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2Lens>>>;
};

export type ComSnapCamerakitAdminV2LenssourceAffectedGroupCursorData = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_AffectedGroupCursorData";
    readonly lastGroupId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceGetAffectedGroupsRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetAffectedGroupsRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly lensLimit: Maybe<Scalars["Int"]["output"]>;
    readonly lensSourceId: Maybe<Scalars["String"]["output"]>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceGetAffectedGroupsResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetAffectedGroupsResponse";
    readonly affectedGroups: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceAffectedGroupByLensSource>>>;
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly hasMore: Maybe<Scalars["Boolean"]["output"]>;
    readonly total: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceGetLensSourceListEnabledRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetLensSourceListEnabledRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceGetLensSourceListEnabledResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetLensSourceListEnabledResponse";
    readonly lensSourceMap: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceLensSourcesMapByType>>>;
};

export type ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetLensSourceListRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceType: Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly query: Maybe<ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequestQuery>;
};

export enum ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequestQuery {
    All = "ALL",
    OnlyDisabled = "ONLY_DISABLED",
    OnlyEnabledUnset = "ONLY_ENABLED_UNSET",
}

export type ComSnapCamerakitAdminV2LenssourceGetLensSourceListResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetLensSourceListResponse";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly hasMore: Maybe<Scalars["Boolean"]["output"]>;
    readonly lensSourceList: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSource>>>;
    readonly total: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceGetSupportedLensSourceTypesRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetSupportedLensSourceTypesRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceGetSupportedLensSourceTypesResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_GetSupportedLensSourceTypesResponse";
    readonly lensSourceTypes: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
};

export type ComSnapCamerakitAdminV2LenssourceLensSourceDisableTask = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_LensSourceDisableTask";
    readonly createdAt: Maybe<GoogleProtobufTimestamp>;
    readonly payload: Maybe<ComSnapCamerakitAdminV2LenssourceLensSourceDisableTaskPayload>;
    readonly taskId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceLensSourceDisableTaskPayload = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_LensSourceDisableTaskPayload";
    readonly lensSourceList: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSource>>>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceLensSourceListCursorData = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_LensSourceListCursorData";
    readonly externalCursor: Maybe<Scalars["String"]["output"]>;
    readonly lastValue: Maybe<Scalars["String"]["output"]>;
    readonly offset: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceLensSourceUpdate = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_LensSourceUpdate";
    readonly enabled: Maybe<Scalars["Boolean"]["output"]>;
    readonly externalId: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceLensSourcesMapByType = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_LensSourcesMapByType";
    readonly lensSourceList: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSource>>>;
    readonly lensSourceType: Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
};

export type ComSnapCamerakitAdminV2LenssourceUpdateLensSourcesRequest = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_UpdateLensSourcesRequest";
    readonly lensSourceUpdates: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceLensSourceUpdate>>>;
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceUpdateLensSourcesResponse = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_UpdateLensSourcesResponse";
    readonly lensSourceList: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSource>>>;
    readonly taskId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitAdminV2LenssourceModelLensSource = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_model_LensSource";
    readonly alias: Maybe<Scalars["String"]["output"]>;
    readonly createdAt: Maybe<GoogleProtobufTimestamp>;
    readonly enabled: Maybe<Scalars["Boolean"]["output"]>;
    readonly externalId: Maybe<Scalars["String"]["output"]>;
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceType: Maybe<ComSnapCamerakitAdminV2LenssourceModelLensSourceType>;
    readonly name: Maybe<Scalars["String"]["output"]>;
    readonly owner: Maybe<Scalars["String"]["output"]>;
    readonly reference: Maybe<Scalars["String"]["output"]>;
    readonly updatedAt: Maybe<GoogleProtobufTimestamp>;
};

export type ComSnapCamerakitAdminV2LenssourceModelLensSourceInfo = {
    readonly __typename?: "com_snap_camerakit_admin_v2_lenssource_model_LensSourceInfo";
    readonly name: Maybe<Scalars["String"]["output"]>;
};

export enum ComSnapCamerakitAdminV2LenssourceModelLensSourceType {
    BusinessProfile = "BUSINESS_PROFILE",
    LensSpace = "LENS_SPACE",
    MediaLibrary = "MEDIA_LIBRARY",
    ScheduleV3 = "SCHEDULE_V3",
    SnapchatUserUnset = "SNAPCHAT_USER_UNSET",
}

export enum ComSnapCamerakitInternalAdminV1ApplicationType {
    ApplicationTypeBoth = "APPLICATION_TYPE_BOTH",
    ApplicationTypeMobile = "APPLICATION_TYPE_MOBILE",
    ApplicationTypeUnset = "APPLICATION_TYPE_UNSET",
    ApplicationTypeWeb = "APPLICATION_TYPE_WEB",
}

export enum ComSnapCamerakitInternalAdminV1BusinessVertical {
    BusinessVerticalAgency = "BUSINESS_VERTICAL_AGENCY",
    BusinessVerticalCarrier = "BUSINESS_VERTICAL_CARRIER",
    BusinessVerticalCommunityVideo = "BUSINESS_VERTICAL_COMMUNITY_VIDEO",
    BusinessVerticalDating = "BUSINESS_VERTICAL_DATING",
    BusinessVerticalFastFood = "BUSINESS_VERTICAL_FAST_FOOD",
    BusinessVerticalFinance = "BUSINESS_VERTICAL_FINANCE",
    BusinessVerticalFoodAndBeverage = "BUSINESS_VERTICAL_FOOD_AND_BEVERAGE",
    BusinessVerticalFoodDelivery = "BUSINESS_VERTICAL_FOOD_DELIVERY",
    BusinessVerticalGaming = "BUSINESS_VERTICAL_GAMING",
    BusinessVerticalHealthAndFitness = "BUSINESS_VERTICAL_HEALTH_AND_FITNESS",
    BusinessVerticalHome = "BUSINESS_VERTICAL_HOME",
    BusinessVerticalLearningAndEducation = "BUSINESS_VERTICAL_LEARNING_AND_EDUCATION",
    BusinessVerticalLocationAndTravel = "BUSINESS_VERTICAL_LOCATION_AND_TRAVEL",
    BusinessVerticalMessaging = "BUSINESS_VERTICAL_MESSAGING",
    BusinessVerticalMusic = "BUSINESS_VERTICAL_MUSIC",
    BusinessVerticalOem = "BUSINESS_VERTICAL_OEM",
    BusinessVerticalOther = "BUSINESS_VERTICAL_OTHER",
    BusinessVerticalPhotoAndVideoEditing = "BUSINESS_VERTICAL_PHOTO_AND_VIDEO_EDITING",
    BusinessVerticalShopping = "BUSINESS_VERTICAL_SHOPPING",
    BusinessVerticalSocial = "BUSINESS_VERTICAL_SOCIAL",
    BusinessVerticalSports = "BUSINESS_VERTICAL_SPORTS",
    BusinessVerticalStreaming = "BUSINESS_VERTICAL_STREAMING",
    BusinessVerticalTransportation = "BUSINESS_VERTICAL_TRANSPORTATION",
    BusinessVerticalUnset = "BUSINESS_VERTICAL_UNSET",
    BusinessVerticalVideoConferencing = "BUSINESS_VERTICAL_VIDEO_CONFERENCING",
}

export enum ComSnapCamerakitInternalAdminV1CameraKitApprovalStatus {
    CameraKitApprovalStatusApproved = "CAMERA_KIT_APPROVAL_STATUS_APPROVED",
    CameraKitApprovalStatusPendingReview = "CAMERA_KIT_APPROVAL_STATUS_PENDING_REVIEW",
    CameraKitApprovalStatusUnset = "CAMERA_KIT_APPROVAL_STATUS_UNSET",
}

export type ComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_CollectOnboardingIntakeFormRequest";
    readonly agency: Maybe<Scalars["Boolean"]["output"]>;
    readonly appStoreUrl: Maybe<Scalars["String"]["output"]>;
    readonly arShoppingUseCase: Maybe<Scalars["Boolean"]["output"]>;
    readonly betaFeedbackOptIn: Maybe<Scalars["Boolean"]["output"]>;
    readonly businessVertical: Maybe<ComSnapCamerakitInternalAdminV1BusinessVertical>;
    readonly cameraKitG: Maybe<Scalars["Boolean"]["output"]>;
    readonly companyName: Maybe<Scalars["String"]["output"]>;
    readonly desiredOutcomes: Maybe<Scalars["String"]["output"]>;
    readonly developmentExpertiseAvailable: Maybe<ComSnapCamerakitInternalAdminV1DevelopmentExpertise>;
    readonly emailAddress: Maybe<Scalars["String"]["output"]>;
    readonly existingSnapKitDeveloper: Maybe<Scalars["Boolean"]["output"]>;
    readonly existingSnapchatAdvertiser: Maybe<Scalars["Boolean"]["output"]>;
    readonly fullName: Maybe<Scalars["String"]["output"]>;
    readonly googlePlayUrl: Maybe<Scalars["String"]["output"]>;
    readonly hardwareOrPhysical: Maybe<Scalars["Boolean"]["output"]>;
    readonly intendedApplicationType: Maybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly lensCreationMethod: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly useCaseDescription: Maybe<Scalars["String"]["output"]>;
    readonly websiteUrl: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_CollectOnboardingIntakeFormResponse";
    readonly approvalStatus: Maybe<ComSnapCamerakitInternalAdminV1CameraKitApprovalStatus>;
};

export type ComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_ConsumeOnboardingTokenRequest";
    readonly organizationId: Maybe<Scalars["String"]["output"]>;
    readonly token: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_ConsumeOnboardingTokenResponse";
    readonly cameraKitMobileAppAccess: Maybe<Scalars["Boolean"]["output"]>;
    readonly cameraKitWebAppAccess: Maybe<Scalars["Boolean"]["output"]>;
    readonly consumeTokenStatus: Maybe<ComSnapCamerakitInternalAdminV1ConsumeTokenStatus>;
};

export enum ComSnapCamerakitInternalAdminV1ConsumeTokenStatus {
    ConsumeTokenStatusAlreadyConsumed = "CONSUME_TOKEN_STATUS_ALREADY_CONSUMED",
    ConsumeTokenStatusConsumed = "CONSUME_TOKEN_STATUS_CONSUMED",
    ConsumeTokenStatusRevoked = "CONSUME_TOKEN_STATUS_REVOKED",
    ConsumeTokenStatusUnconsumed = "CONSUME_TOKEN_STATUS_UNCONSUMED",
    ConsumeTokenStatusUnset = "CONSUME_TOKEN_STATUS_UNSET",
}

export enum ComSnapCamerakitInternalAdminV1DevelopmentExpertise {
    DevelopmentExpertiseInternal = "DEVELOPMENT_EXPERTISE_INTERNAL",
    DevelopmentExpertiseOutsource = "DEVELOPMENT_EXPERTISE_OUTSOURCE",
    DevelopmentExpertiseRequired = "DEVELOPMENT_EXPERTISE_REQUIRED",
    DevelopmentExpertiseUnset = "DEVELOPMENT_EXPERTISE_UNSET",
}

export type ComSnapCamerakitInternalAdminV1InternalLabels = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_InternalLabels";
    readonly firstParty: Maybe<Scalars["Boolean"]["output"]>;
    readonly live: Maybe<Scalars["Boolean"]["output"]>;
    readonly managed: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ListTokenRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_ListTokenRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly endDateMillis: Maybe<Scalars["Long"]["output"]>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly startDateMillis: Maybe<Scalars["Long"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ListTokenResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_ListTokenResponse";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly tokens: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type ComSnapCamerakitInternalAdminV1NotifyEmailRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_NotifyEmailRequest";
    readonly formIds: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    /** @deprecated deprecated in proto */
    readonly notifyEmails: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    /** @deprecated deprecated in proto */
    readonly platformType: Maybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly templateId: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1NotifyEmailResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_NotifyEmailResponse";
    readonly successes: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
};

export type ComSnapCamerakitInternalAdminV1OnboardingToken = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_OnboardingToken";
    readonly cameraKitMobileAppAccess: Maybe<Scalars["Boolean"]["output"]>;
    readonly cameraKitWebAppAccess: Maybe<Scalars["Boolean"]["output"]>;
    readonly consumedTimeMillis: Maybe<Scalars["Long"]["output"]>;
    readonly consumingOrganization: Maybe<Scalars["String"]["output"]>;
    readonly createdTimeMillis: Maybe<Scalars["Long"]["output"]>;
    readonly firstVerifiedTimeMillis: Maybe<Scalars["Long"]["output"]>;
    readonly isRevoked: Maybe<Scalars["Boolean"]["output"]>;
    readonly requestingEmail: Maybe<Scalars["String"]["output"]>;
    readonly tokenValue: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1Organization = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_Organization";
    readonly id: Maybe<Scalars["String"]["output"]>;
    readonly internalLabels: Maybe<ComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly name: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1RevokeTokenRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_RevokeTokenRequest";
    readonly token: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1RevokeTokenResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_RevokeTokenResponse";
    readonly tokenRevoked: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1SearchOrganizationRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_SearchOrganizationRequest";
    readonly query: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1SearchOrganizationResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_SearchOrganizationResponse";
    readonly organizations: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitInternalAdminV1Organization>>>;
};

export type ComSnapCamerakitInternalAdminV1SearchTokenRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_SearchTokenRequest";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly requestingEmail: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1SearchTokenResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_SearchTokenResponse";
    readonly cursor: Maybe<Scalars["String"]["output"]>;
    readonly tokens: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type ComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_UpdateOrganizationInternalLabelsRequest";
    readonly internalLabels: Maybe<ComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly orgId: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_UpdateOrganizationInternalLabelsResponse";
    readonly internalLabels: Maybe<ComSnapCamerakitInternalAdminV1InternalLabels>;
};

export type ComSnapCamerakitInternalAdminV1ValidateOnboardingTokenRequest = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_ValidateOnboardingTokenRequest";
    readonly token: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ValidateOnboardingTokenResponse = {
    readonly __typename?: "com_snap_camerakit_internal_admin_v1_ValidateOnboardingTokenResponse";
    readonly onboardingTokenStatus: Maybe<ComSnapCamerakitInternalAdminV1ValidateTokenStatus>;
};

export enum ComSnapCamerakitInternalAdminV1ValidateTokenStatus {
    ValidateTokenStatusAvailable = "VALIDATE_TOKEN_STATUS_AVAILABLE",
    ValidateTokenStatusConsumed = "VALIDATE_TOKEN_STATUS_CONSUMED",
    ValidateTokenStatusRevoked = "VALIDATE_TOKEN_STATUS_REVOKED",
    ValidateTokenStatusUnset = "VALIDATE_TOKEN_STATUS_UNSET",
}

export type GoogleProtobufTimestamp = {
    readonly __typename?: "google_protobuf_Timestamp";
    readonly nanos: Maybe<Scalars["Int"]["output"]>;
    readonly seconds: Maybe<Scalars["Long"]["output"]>;
};

export enum SnapchatReportingOrganicAssetType {
    AdKitApp = "AD_KIT_APP",
    AssetTypeUnset = "ASSET_TYPE_UNSET",
    CamkitLens = "CAMKIT_LENS",
    Game = "GAME",
    /** @deprecated deprecated in proto */
    Highlight = "HIGHLIGHT",
    Lens = "LENS",
    Organization = "ORGANIZATION",
    Place = "PLACE",
    PlaceCollection = "PLACE_COLLECTION",
    PlaceCountry = "PLACE_COUNTRY",
    PlaceRegion = "PLACE_REGION",
    Profile = "PROFILE",
    QrSnapcode = "QR_SNAPCODE",
    SavedStory = "SAVED_STORY",
    Snap = "SNAP",
    Snapcode = "SNAPCODE",
    Spotlight = "SPOTLIGHT",
    Store = "STORE",
    Story = "STORY",
    Tile = "TILE",
    User = "USER",
}

export enum SnapchatReportingOrganicConversionReportTime {
    Conversion = "CONVERSION",
    ConversionReportingTimeUnset = "CONVERSION_REPORTING_TIME_UNSET",
    Exposure = "EXPOSURE",
}

export enum SnapchatReportingOrganicConversionSourceType {
    App = "APP",
    ConversionSourceTypeUnset = "CONVERSION_SOURCE_TYPE_UNSET",
    Native = "NATIVE",
    Offline = "OFFLINE",
    TotalConversions = "TOTAL_CONVERSIONS",
    TotalOffPlatform = "TOTAL_OFF_PLATFORM",
    Web = "WEB",
}

export enum SnapchatReportingOrganicConversionSwipeUpWindow {
    ConversionSwipeUpWindowUnset = "CONVERSION_SWIPE_UP_WINDOW_UNSET",
    SwipeUp_1Day = "SWIPE_UP_1_DAY",
    SwipeUp_7Day = "SWIPE_UP_7_DAY",
    SwipeUp_28Day = "SWIPE_UP_28_DAY",
}

export enum SnapchatReportingOrganicConversionViewWindow {
    ConversionViewWindowUnset = "CONVERSION_VIEW_WINDOW_UNSET",
    View_1Day = "VIEW_1_DAY",
    View_1Hour = "VIEW_1_HOUR",
    View_3Hour = "VIEW_3_HOUR",
    View_6Hour = "VIEW_6_HOUR",
    View_7Day = "VIEW_7_DAY",
}

export type SnapchatReportingOrganicGetOrganicStatsRequest = {
    readonly __typename?: "snapchat_reporting_organic_GetOrganicStatsRequest";
    readonly assetId: Maybe<Scalars["String"]["output"]>;
    readonly assetType: Maybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownAssetType: Maybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownIds: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly conversionReportTime: Maybe<SnapchatReportingOrganicConversionReportTime>;
    readonly conversionSourceType: Maybe<SnapchatReportingOrganicConversionSourceType>;
    readonly conversionSwipeUpWindow: Maybe<SnapchatReportingOrganicConversionSwipeUpWindow>;
    readonly conversionViewWindow: Maybe<SnapchatReportingOrganicConversionViewWindow>;
    readonly endTime: Maybe<GoogleProtobufTimestamp>;
    readonly fields: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsField>>>;
    readonly granularity: Maybe<SnapchatReportingOrganicGranularity>;
    readonly isTest: Maybe<Scalars["Boolean"]["output"]>;
    readonly limit: Maybe<Scalars["Int"]["output"]>;
    readonly offset: Maybe<Scalars["Int"]["output"]>;
    readonly placeCollectionId: Maybe<Scalars["String"]["output"]>;
    readonly profileId: Maybe<Scalars["String"]["output"]>;
    readonly publisherId: Maybe<Scalars["String"]["output"]>;
    readonly requestId: Maybe<Scalars["String"]["output"]>;
    readonly requestType: Maybe<SnapchatReportingOrganicRequestType>;
    readonly sortBy: Maybe<SnapchatReportingOrganicMetricField>;
    readonly sortByDimension: Maybe<SnapchatReportingOrganicUserDimension>;
    readonly sortByDimensionBreakdowns: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
    readonly sortDirection: Maybe<SnapchatReportingOrganicSortDirection>;
    readonly startTime: Maybe<GoogleProtobufTimestamp>;
    readonly topDimensionLimit: Maybe<Scalars["Int"]["output"]>;
    readonly userId: Maybe<Scalars["String"]["output"]>;
};

export type SnapchatReportingOrganicGetOrganicStatsResponse = {
    readonly __typename?: "snapchat_reporting_organic_GetOrganicStatsResponse";
    readonly responseEntry: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsResponseEntry>>>;
};

export enum SnapchatReportingOrganicGranularity {
    Day = "DAY",
    GranularityUnset = "GRANULARITY_UNSET",
    Hour = "HOUR",
    Lifetime = "LIFETIME",
    Month = "MONTH",
    Total = "TOTAL",
}

export enum SnapchatReportingOrganicMetricField {
    AddToCart = "ADD_TO_CART",
    AdsSubscribes = "ADS_SUBSCRIBES",
    AdCompletes = "AD_COMPLETES",
    AdQuartile_1 = "AD_QUARTILE_1",
    AdQuartile_2 = "AD_QUARTILE_2",
    AdQuartile_3 = "AD_QUARTILE_3",
    AttachmentConversion = "ATTACHMENT_CONVERSION",
    AttachmentViewers = "ATTACHMENT_VIEWERS",
    AttachmentViewersInsight = "ATTACHMENT_VIEWERS_INSIGHT",
    AttachmentViews = "ATTACHMENT_VIEWS",
    AttachmentViewTimeMillis = "ATTACHMENT_VIEW_TIME_MILLIS",
    AverageInteractionTime = "AVERAGE_INTERACTION_TIME",
    AverageUserViewTime = "AVERAGE_USER_VIEW_TIME",
    AvgViewTimeMillis = "AVG_VIEW_TIME_MILLIS",
    CameraPlayTimeMillis = "CAMERA_PLAY_TIME_MILLIS",
    CaptureRate = "CAPTURE_RATE",
    ChatUniques = "CHAT_UNIQUES",
    Completes = "COMPLETES",
    CompleteSnapViewers = "COMPLETE_SNAP_VIEWERS",
    CompleteSnapViews = "COMPLETE_SNAP_VIEWS",
    ConversionAchievementUnlocked = "CONVERSION_ACHIEVEMENT_UNLOCKED",
    ConversionAchievementUnlockedSwipeUp = "CONVERSION_ACHIEVEMENT_UNLOCKED_SWIPE_UP",
    ConversionAchievementUnlockedView = "CONVERSION_ACHIEVEMENT_UNLOCKED_VIEW",
    ConversionAddBilling = "CONVERSION_ADD_BILLING",
    ConversionAddBillingSwipeUp = "CONVERSION_ADD_BILLING_SWIPE_UP",
    ConversionAddBillingView = "CONVERSION_ADD_BILLING_VIEW",
    ConversionAddCart = "CONVERSION_ADD_CART",
    ConversionAddCartSwipeUp = "CONVERSION_ADD_CART_SWIPE_UP",
    ConversionAddCartView = "CONVERSION_ADD_CART_VIEW",
    ConversionAddToWishlist = "CONVERSION_ADD_TO_WISHLIST",
    ConversionAddToWishlistSwipeUp = "CONVERSION_ADD_TO_WISHLIST_SWIPE_UP",
    ConversionAddToWishlistView = "CONVERSION_ADD_TO_WISHLIST_VIEW",
    ConversionAdClick = "CONVERSION_AD_CLICK",
    ConversionAdClickSwipeUp = "CONVERSION_AD_CLICK_SWIPE_UP",
    ConversionAdClickView = "CONVERSION_AD_CLICK_VIEW",
    ConversionAdView = "CONVERSION_AD_VIEW",
    ConversionAdViewSwipeUp = "CONVERSION_AD_VIEW_SWIPE_UP",
    ConversionAdViewView = "CONVERSION_AD_VIEW_VIEW",
    ConversionAppOpens = "CONVERSION_APP_OPENS",
    ConversionAppOpensSwipeUp = "CONVERSION_APP_OPENS_SWIPE_UP",
    ConversionAppOpensView = "CONVERSION_APP_OPENS_VIEW",
    ConversionCompleteTutorial = "CONVERSION_COMPLETE_TUTORIAL",
    ConversionCompleteTutorialSwipeUp = "CONVERSION_COMPLETE_TUTORIAL_SWIPE_UP",
    ConversionCompleteTutorialView = "CONVERSION_COMPLETE_TUTORIAL_VIEW",
    ConversionInvite = "CONVERSION_INVITE",
    ConversionInviteSwipeUp = "CONVERSION_INVITE_SWIPE_UP",
    ConversionInviteView = "CONVERSION_INVITE_VIEW",
    ConversionLevelCompletes = "CONVERSION_LEVEL_COMPLETES",
    ConversionLevelCompletesSwipeUp = "CONVERSION_LEVEL_COMPLETES_SWIPE_UP",
    ConversionLevelCompletesView = "CONVERSION_LEVEL_COMPLETES_VIEW",
    ConversionListView = "CONVERSION_LIST_VIEW",
    ConversionListViewSwipeUp = "CONVERSION_LIST_VIEW_SWIPE_UP",
    ConversionListViewView = "CONVERSION_LIST_VIEW_VIEW",
    ConversionLogin = "CONVERSION_LOGIN",
    ConversionLoginSwipeUp = "CONVERSION_LOGIN_SWIPE_UP",
    ConversionLoginView = "CONVERSION_LOGIN_VIEW",
    ConversionPageViews = "CONVERSION_PAGE_VIEWS",
    ConversionPageViewsSwipeUp = "CONVERSION_PAGE_VIEWS_SWIPE_UP",
    ConversionPageViewsView = "CONVERSION_PAGE_VIEWS_VIEW",
    ConversionPurchases = "CONVERSION_PURCHASES",
    ConversionPurchasesCurrencyValue = "CONVERSION_PURCHASES_CURRENCY_VALUE",
    ConversionPurchasesSwipeUp = "CONVERSION_PURCHASES_SWIPE_UP",
    ConversionPurchasesValueSwipeUp = "CONVERSION_PURCHASES_VALUE_SWIPE_UP",
    ConversionPurchasesValueView = "CONVERSION_PURCHASES_VALUE_VIEW",
    ConversionPurchasesView = "CONVERSION_PURCHASES_VIEW",
    ConversionRate = "CONVERSION_RATE",
    ConversionRateSwipeUp = "CONVERSION_RATE_SWIPE_UP",
    ConversionRateView = "CONVERSION_RATE_VIEW",
    ConversionReserve = "CONVERSION_RESERVE",
    ConversionReserveSwipeUp = "CONVERSION_RESERVE_SWIPE_UP",
    ConversionReserveView = "CONVERSION_RESERVE_VIEW",
    ConversionSave = "CONVERSION_SAVE",
    ConversionSaveSwipeUp = "CONVERSION_SAVE_SWIPE_UP",
    ConversionSaveView = "CONVERSION_SAVE_VIEW",
    ConversionSearches = "CONVERSION_SEARCHES",
    ConversionSearchesSwipeUp = "CONVERSION_SEARCHES_SWIPE_UP",
    ConversionSearchesView = "CONVERSION_SEARCHES_VIEW",
    ConversionShare = "CONVERSION_SHARE",
    ConversionShareSwipeUp = "CONVERSION_SHARE_SWIPE_UP",
    ConversionShareView = "CONVERSION_SHARE_VIEW",
    ConversionSignUps = "CONVERSION_SIGN_UPS",
    ConversionSignUpsSwipeUp = "CONVERSION_SIGN_UPS_SWIPE_UP",
    ConversionSignUpsView = "CONVERSION_SIGN_UPS_VIEW",
    ConversionSpendCredits = "CONVERSION_SPEND_CREDITS",
    ConversionSpendCreditsSwipeUp = "CONVERSION_SPEND_CREDITS_SWIPE_UP",
    ConversionSpendCreditsView = "CONVERSION_SPEND_CREDITS_VIEW",
    ConversionStartCheckout = "CONVERSION_START_CHECKOUT",
    ConversionStartCheckoutSwipeUp = "CONVERSION_START_CHECKOUT_SWIPE_UP",
    ConversionStartCheckoutView = "CONVERSION_START_CHECKOUT_VIEW",
    ConversionStartTrial = "CONVERSION_START_TRIAL",
    ConversionStartTrialSwipeUp = "CONVERSION_START_TRIAL_SWIPE_UP",
    ConversionStartTrialView = "CONVERSION_START_TRIAL_VIEW",
    ConversionSubscribe = "CONVERSION_SUBSCRIBE",
    ConversionSubscribeSwipeUp = "CONVERSION_SUBSCRIBE_SWIPE_UP",
    ConversionSubscribeView = "CONVERSION_SUBSCRIBE_VIEW",
    ConversionViewContent = "CONVERSION_VIEW_CONTENT",
    ConversionViewContentSwipeUp = "CONVERSION_VIEW_CONTENT_SWIPE_UP",
    ConversionViewContentView = "CONVERSION_VIEW_CONTENT_VIEW",
    ConversionVisit = "CONVERSION_VISIT",
    ConversionVisitSwipeUp = "CONVERSION_VISIT_SWIPE_UP",
    ConversionVisitView = "CONVERSION_VISIT_VIEW",
    CoreUsers = "CORE_USERS",
    Creates = "CREATES",
    DailyUniques = "DAILY_UNIQUES",
    DigitalGoodCardCancel = "DIGITAL_GOOD_CARD_CANCEL",
    DigitalGoodCardOpens = "DIGITAL_GOOD_CARD_OPENS",
    DigitalGoodPurchase = "DIGITAL_GOOD_PURCHASE",
    DigitalGoodPurchasesPerUser = "DIGITAL_GOOD_PURCHASES_PER_USER",
    DigitalGoodTokenEarned = "DIGITAL_GOOD_TOKEN_EARNED",
    DigitalGoodUniquePurchasers = "DIGITAL_GOOD_UNIQUE_PURCHASERS",
    DownloadTime = "DOWNLOAD_TIME",
    DropOffRate = "DROP_OFF_RATE",
    Ecpm = "ECPM",
    ExternalStoreClick = "EXTERNAL_STORE_CLICK",
    Favorites = "FAVORITES",
    FilledImpressions = "FILLED_IMPRESSIONS",
    FrequentUsers = "FREQUENT_USERS",
    /** @deprecated deprecated in proto */
    HighlightAvgViewTimeMillis = "HIGHLIGHT_AVG_VIEW_TIME_MILLIS",
    /** @deprecated deprecated in proto */
    HighlightSubscribes = "HIGHLIGHT_SUBSCRIBES",
    /** @deprecated deprecated in proto */
    HighlightUniques = "HIGHLIGHT_UNIQUES",
    /** @deprecated deprecated in proto */
    HighlightViews = "HIGHLIGHT_VIEWS",
    /** @deprecated deprecated in proto */
    HighlightViewTimeMillis = "HIGHLIGHT_VIEW_TIME_MILLIS",
    Interactions = "INTERACTIONS",
    InteractionTime = "INTERACTION_TIME",
    LensAveragePlaytimeMillis = "LENS_AVERAGE_PLAYTIME_MILLIS",
    LensAvgViewTimeMillis = "LENS_AVG_VIEW_TIME_MILLIS",
    LensCommandKeywordDetected = "LENS_COMMAND_KEYWORD_DETECTED",
    LensDauOverMau = "LENS_DAU_OVER_MAU",
    LensDauOverWau = "LENS_DAU_OVER_WAU",
    LensFaceFound = "LENS_FACE_FOUND",
    LensFaceLost = "LENS_FACE_LOST",
    LensLanguageDisplayed = "LENS_LANGUAGE_DISPLAYED",
    LensLongPlays = "LENS_LONG_PLAYS",
    LensLongPlayRatio = "LENS_LONG_PLAY_RATIO",
    LensMarkerTracked = "LENS_MARKER_TRACKED",
    LensMau = "LENS_MAU",
    LensMultiuserSessionJoined = "LENS_MULTIUSER_SESSION_JOINED",
    LensMultiuserSessionShared = "LENS_MULTIUSER_SESSION_SHARED",
    LensMultiuserSessionStarted = "LENS_MULTIUSER_SESSION_STARTED",
    LensObjectTracked = "LENS_OBJECT_TRACKED",
    LensObjectTracked_3D = "LENS_OBJECT_TRACKED_3D",
    LensPlays = "LENS_PLAYS",
    LensPlaysLast_90Days = "LENS_PLAYS_LAST_90_DAYS",
    LensPosterUniques = "LENS_POSTER_UNIQUES",
    LensPosterUniquesS11 = "LENS_POSTER_UNIQUES_S11",
    LensPosterUniquesUs = "LENS_POSTER_UNIQUES_US",
    LensPosts = "LENS_POSTS",
    LensPrivateStoryPosts = "LENS_PRIVATE_STORY_POSTS",
    LensPublicStoryPosts = "LENS_PUBLIC_STORY_POSTS",
    LensShares = "LENS_SHARES",
    LensSnapcodeScans = "LENS_SNAPCODE_SCANS",
    LensSpotlightPosterUniques = "LENS_SPOTLIGHT_POSTER_UNIQUES",
    LensSpotlightPosterUniquesS11 = "LENS_SPOTLIGHT_POSTER_UNIQUES_S11",
    LensSpotlightPosterUniquesUs = "LENS_SPOTLIGHT_POSTER_UNIQUES_US",
    LensSpotlightPosts = "LENS_SPOTLIGHT_POSTS",
    LensSubscribers = "LENS_SUBSCRIBERS",
    LensSubscribersGained = "LENS_SUBSCRIBERS_GAINED",
    LensSubscribes = "LENS_SUBSCRIBES",
    LensTap = "LENS_TAP",
    LensTouchEnded = "LENS_TOUCH_ENDED",
    LensTouchMoved = "LENS_TOUCH_MOVED",
    LensTouchStart = "LENS_TOUCH_START",
    LensUniques = "LENS_UNIQUES",
    LensViewers = "LENS_VIEWERS",
    LensViews = "LENS_VIEWS",
    LensViewTimeMillis = "LENS_VIEW_TIME_MILLIS",
    LensVoiceKeywordDetected = "LENS_VOICE_KEYWORD_DETECTED",
    LensVoiceTranscribed = "LENS_VOICE_TRANSCRIBED",
    LongImpressions = "LONG_IMPRESSIONS",
    LoyalUsers = "LOYAL_USERS",
    MetricFieldUnset = "METRIC_FIELD_UNSET",
    NetRevenue = "NET_REVENUE",
    NewUsers = "NEW_USERS",
    NonSubscribeAttachmentView = "NON_SUBSCRIBE_ATTACHMENT_VIEW",
    NonSubscribeAttachmentViewer = "NON_SUBSCRIBE_ATTACHMENT_VIEWER",
    PlacesCalls = "PLACES_CALLS",
    PlacesCheckIns = "PLACES_CHECK_INS",
    PlacesDirectionRequests = "PLACES_DIRECTION_REQUESTS",
    PlacesFavorites = "PLACES_FAVORITES",
    PlacesHoursRequests = "PLACES_HOURS_REQUESTS",
    PlacesMenuVisits = "PLACES_MENU_VISITS",
    PlacesOrders = "PLACES_ORDERS",
    PlacesPhysicalVisitors = "PLACES_PHYSICAL_VISITORS",
    PlacesPhysicalVisits = "PLACES_PHYSICAL_VISITS",
    PlacesUniqueHoursRequests = "PLACES_UNIQUE_HOURS_REQUESTS",
    PlacesUniqueUserCalls = "PLACES_UNIQUE_USER_CALLS",
    PlacesUniqueUserDirectionRequests = "PLACES_UNIQUE_USER_DIRECTION_REQUESTS",
    PlacesUniqueUserMenuVisits = "PLACES_UNIQUE_USER_MENU_VISITS",
    PlacesUniqueUserOrders = "PLACES_UNIQUE_USER_ORDERS",
    PlacesViewers = "PLACES_VIEWERS",
    PlacesViews = "PLACES_VIEWS",
    PlacesVisitFrequency = "PLACES_VISIT_FREQUENCY",
    PlayTimeMillis = "PLAY_TIME_MILLIS",
    PlayTimeMillisLast_90Days = "PLAY_TIME_MILLIS_LAST_90_DAYS",
    ProductAvgPlayTimeMillis = "PRODUCT_AVG_PLAY_TIME_MILLIS",
    ProductPlays = "PRODUCT_PLAYS",
    ProductPlayTimeMillis = "PRODUCT_PLAY_TIME_MILLIS",
    ProductShares = "PRODUCT_SHARES",
    ProductSwipes = "PRODUCT_SWIPES",
    ProfilePaidViews = "PROFILE_PAID_VIEWS",
    ProfileViews = "PROFILE_VIEWS",
    QrScans = "QR_SCANS",
    Replies = "REPLIES",
    Requests = "REQUESTS",
    ReturningUsers = "RETURNING_USERS",
    Revenue = "REVENUE",
    SavedStoryAvgViewTimeMillis = "SAVED_STORY_AVG_VIEW_TIME_MILLIS",
    SavedStoryFavorites = "SAVED_STORY_FAVORITES",
    SavedStoryScreenshots = "SAVED_STORY_SCREENSHOTS",
    SavedStorySharedRecipientCount = "SAVED_STORY_SHARED_RECIPIENT_COUNT",
    SavedStoryShares = "SAVED_STORY_SHARES",
    SavedStorySnapAvgViewTimeMillis = "SAVED_STORY_SNAP_AVG_VIEW_TIME_MILLIS",
    SavedStorySnapCombinedUniques = "SAVED_STORY_SNAP_COMBINED_UNIQUES",
    SavedStorySnapCombinedViews = "SAVED_STORY_SNAP_COMBINED_VIEWS",
    SavedStorySnapPaidUniques = "SAVED_STORY_SNAP_PAID_UNIQUES",
    SavedStorySnapPaidViews = "SAVED_STORY_SNAP_PAID_VIEWS",
    SavedStorySnapSharers = "SAVED_STORY_SNAP_SHARERS",
    SavedStorySnapViewers = "SAVED_STORY_SNAP_VIEWERS",
    SavedStorySnapViewersInsight = "SAVED_STORY_SNAP_VIEWERS_INSIGHT",
    SavedStorySnapViews = "SAVED_STORY_SNAP_VIEWS",
    SavedStorySubscribes = "SAVED_STORY_SUBSCRIBES",
    SavedStoryUniques = "SAVED_STORY_UNIQUES",
    SavedStoryViewers = "SAVED_STORY_VIEWERS",
    SavedStoryViews = "SAVED_STORY_VIEWS",
    SavedStoryViewTimeMillis = "SAVED_STORY_VIEW_TIME_MILLIS",
    Scans = "SCANS",
    ScanAvgPlayTimeMillis = "SCAN_AVG_PLAY_TIME_MILLIS",
    ScanLensFavorites = "SCAN_LENS_FAVORITES",
    ScanLensLongPlays = "SCAN_LENS_LONG_PLAYS",
    ScanLensOnlyViewers = "SCAN_LENS_ONLY_VIEWERS",
    ScanLensPlays = "SCAN_LENS_PLAYS",
    ScanLensPlayTimeMillis = "SCAN_LENS_PLAY_TIME_MILLIS",
    ScanLensShares = "SCAN_LENS_SHARES",
    ScanLensSubscribes = "SCAN_LENS_SUBSCRIBES",
    ScanLensSwipeUps = "SCAN_LENS_SWIPE_UPS",
    ScanLensUniques = "SCAN_LENS_UNIQUES",
    ScanLensViews = "SCAN_LENS_VIEWS",
    ScanLensViewTimeMillis = "SCAN_LENS_VIEW_TIME_MILLIS",
    Screenshots = "SCREENSHOTS",
    Shares = "SHARES",
    SnapcodeScans = "SNAPCODE_SCANS",
    SnapCombinedUniques = "SNAP_COMBINED_UNIQUES",
    SnapCombinedViews = "SNAP_COMBINED_VIEWS",
    SnapPaidUniques = "SNAP_PAID_UNIQUES",
    SnapPaidViews = "SNAP_PAID_VIEWS",
    SnapViewers = "SNAP_VIEWERS",
    SnapViews = "SNAP_VIEWS",
    SnapViewTimeMillis = "SNAP_VIEW_TIME_MILLIS",
    SnapWithAttachmentView = "SNAP_WITH_ATTACHMENT_VIEW",
    SnapWithAttachmentViewer = "SNAP_WITH_ATTACHMENT_VIEWER",
    SocialUnlocks = "SOCIAL_UNLOCKS",
    SpotlightAvgViewTimeMillis = "SPOTLIGHT_AVG_VIEW_TIME_MILLIS",
    SpotlightCombinedUniques = "SPOTLIGHT_COMBINED_UNIQUES",
    SpotlightCombinedViews = "SPOTLIGHT_COMBINED_VIEWS",
    SpotlightFavorites = "SPOTLIGHT_FAVORITES",
    SpotlightPaidUniques = "SPOTLIGHT_PAID_UNIQUES",
    SpotlightPaidViews = "SPOTLIGHT_PAID_VIEWS",
    SpotlightScreenshots = "SPOTLIGHT_SCREENSHOTS",
    SpotlightShares = "SPOTLIGHT_SHARES",
    SpotlightSubscribersGained = "SPOTLIGHT_SUBSCRIBERS_GAINED",
    SpotlightSubscribes = "SPOTLIGHT_SUBSCRIBES",
    SpotlightUniques = "SPOTLIGHT_UNIQUES",
    SpotlightViews = "SPOTLIGHT_VIEWS",
    SpotlightViewTimeMillis = "SPOTLIGHT_VIEW_TIME_MILLIS",
    StoreCategoryView = "STORE_CATEGORY_VIEW",
    StoreCategoryViewer = "STORE_CATEGORY_VIEWER",
    StorePageView = "STORE_PAGE_VIEW",
    StoreProductView = "STORE_PRODUCT_VIEW",
    StoreProductViewer = "STORE_PRODUCT_VIEWER",
    StoreViewTime = "STORE_VIEW_TIME",
    StoreVisitors = "STORE_VISITORS",
    StoryAvgViewTimeMillis = "STORY_AVG_VIEW_TIME_MILLIS",
    StoryFavorites = "STORY_FAVORITES",
    StorySubscribers = "STORY_SUBSCRIBERS",
    StorySubscribersGained = "STORY_SUBSCRIBERS_GAINED",
    StorySubscribes = "STORY_SUBSCRIBES",
    StoryUniques = "STORY_UNIQUES",
    StoryViewers = "STORY_VIEWERS",
    StoryViews = "STORY_VIEWS",
    StoryViewTimeMillis = "STORY_VIEW_TIME_MILLIS",
    Subscribers = "SUBSCRIBERS",
    SubscribersGained = "SUBSCRIBERS_GAINED",
    Subscribes = "SUBSCRIBES",
    SwipeDowns = "SWIPE_DOWNS",
    SwipeUps = "SWIPE_UPS",
    TapBack = "TAP_BACK",
    TapForward = "TAP_FORWARD",
    TextAttachmentViews = "TEXT_ATTACHMENT_VIEWS",
    TileAvgSnapViewed = "TILE_AVG_SNAP_VIEWED",
    TileAvgTimeViewed = "TILE_AVG_TIME_VIEWED",
    TileCtr = "TILE_CTR",
    TileIndexCtr = "TILE_INDEX_CTR",
    TileSnapViewer = "TILE_SNAP_VIEWER",
    TileTap = "TILE_TAP",
    TileView = "TILE_VIEW",
    TileViewer = "TILE_VIEWER",
    TileViewRatio = "TILE_VIEW_RATIO",
    TileViewTime = "TILE_VIEW_TIME",
    UniqueLensSnapCreates = "UNIQUE_LENS_SNAP_CREATES",
    UniqueProductsViewed = "UNIQUE_PRODUCTS_VIEWED",
    UniqueScreenshots = "UNIQUE_SCREENSHOTS",
    UniqueSessions = "UNIQUE_SESSIONS",
    UniqueSwipers = "UNIQUE_SWIPERS",
    UniqueTopsnapPerUser = "UNIQUE_TOPSNAP_PER_USER",
    UniqueTopsnapViews = "UNIQUE_TOPSNAP_VIEWS",
    UniqueTopsnapViewsInsight = "UNIQUE_TOPSNAP_VIEWS_INSIGHT",
    Unsubscribes = "UNSUBSCRIBES",
    VideoAttachmentViews = "VIDEO_ATTACHMENT_VIEWS",
    Viewers = "VIEWERS",
    ViewersInsight = "VIEWERS_INSIGHT",
    Views = "VIEWS",
    ViewTimeMillis = "VIEW_TIME_MILLIS",
}

export type SnapchatReportingOrganicOrganicStat = {
    readonly __typename?: "snapchat_reporting_organic_OrganicStat";
    readonly dimensionBreakdown: Maybe<Scalars["String"]["output"]>;
    readonly percentageValue: Maybe<Scalars["Float"]["output"]>;
    readonly value: Maybe<Scalars["String"]["output"]>;
};

export type SnapchatReportingOrganicOrganicStatsField = {
    readonly __typename?: "snapchat_reporting_organic_OrganicStatsField";
    readonly fieldName: Maybe<SnapchatReportingOrganicMetricField>;
    readonly reportDimension: Maybe<SnapchatReportingOrganicUserDimension>;
    readonly reportDimensionFilters: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
};

export type SnapchatReportingOrganicOrganicStatsResponseDimensionEntry = {
    readonly __typename?: "snapchat_reporting_organic_OrganicStatsResponseDimensionEntry";
    readonly field: Maybe<SnapchatReportingOrganicOrganicStatsField>;
    readonly stats: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStat>>>;
};

export type SnapchatReportingOrganicOrganicStatsResponseEntry = {
    readonly __typename?: "snapchat_reporting_organic_OrganicStatsResponseEntry";
    readonly assetId: Maybe<Scalars["String"]["output"]>;
    readonly assetType: Maybe<SnapchatReportingOrganicAssetType>;
    readonly statsResponseTimeEntry: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsResponseTimeEntry>>>;
};

export type SnapchatReportingOrganicOrganicStatsResponseTimeEntry = {
    readonly __typename?: "snapchat_reporting_organic_OrganicStatsResponseTimeEntry";
    readonly stats: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsResponseDimensionEntry>>>;
    readonly timestamp: Maybe<GoogleProtobufTimestamp>;
};

export enum SnapchatReportingOrganicRequestType {
    PlaceRequest = "PLACE_REQUEST",
    PublicProfile = "PUBLIC_PROFILE",
    PublisherReport = "PUBLISHER_REPORT",
    StoreReport = "STORE_REPORT",
    Unset = "UNSET",
}

export enum SnapchatReportingOrganicSortDirection {
    SortDirectionAsc = "SORT_DIRECTION_ASC",
    SortDirectionDesc = "SORT_DIRECTION_DESC",
    SortDirectionUnset = "SORT_DIRECTION_UNSET",
}

export enum SnapchatReportingOrganicUserDimension {
    Age = "AGE",
    AgeGender = "AGE_GENDER",
    Country = "COUNTRY",
    CountryAge = "COUNTRY_AGE",
    CountryGender = "COUNTRY_GENDER",
    CountryGenderSponsorType = "COUNTRY_GENDER_SPONSOR_TYPE",
    CountrySponsorType = "COUNTRY_SPONSOR_TYPE",
    CountrySubscription = "COUNTRY_SUBSCRIPTION",
    CountrySubscriptionSponsorType = "COUNTRY_SUBSCRIPTION_SPONSOR_TYPE",
    DigitalGood = "DIGITAL_GOOD",
    FormatType = "FORMAT_TYPE",
    Gender = "GENDER",
    InterestCategoryId = "INTEREST_CATEGORY_ID",
    Os = "OS",
    Placement = "PLACEMENT",
    Platform = "PLATFORM",
    Product = "PRODUCT",
    ProductCategory = "PRODUCT_CATEGORY",
    Region = "REGION",
    RevenueType = "REVENUE_TYPE",
    RevenueTypeInternal = "REVENUE_TYPE_INTERNAL",
    SdkVersion = "SDK_VERSION",
    SponsorType = "SPONSOR_TYPE",
    Subscription = "SUBSCRIPTION",
    UserDimensionUnset = "USER_DIMENSION_UNSET",
}
